import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import Paper from '@material-ui/core/Paper';
import TextField from "@material-ui/core/TextField";
import { isNotEmpty } from '../..//../../utils/Validator';
import { parseDate } from '../../../../utils/Utils';

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Link from "@material-ui/core/Link";
//import PhysicianLocationDtlsTbl from "./PhysicianLocationDtlsTbl";
import Button from "@material-ui/core/Button";
import { Avatar, Typography, Box } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Grid from '@material-ui/core/Grid';
import CheckboxSelection from '../CheckboxSelection';
import AddIcon from '@material-ui/icons/Add';
import UndoIcon from '@material-ui/icons/Undo';
import RestoreIcon from '@material-ui/icons/Restore';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ProviderService from "../../../../Services/ProviderService";
import ConfirmationDialog from "../ConfirmationDialog";
import FacilityLocationServicesDtlsTbl from "./FacilityLocationServicesDtlsTbl";
import FacilityLocationSpclDtlsTbl from "./FacilityLocationSpclDtlsTbl";
import FacilityLocationFocusDtlsTbl from "./FacilityLocationFocusDtlsTbl";
import FacilityLocationLangDtlsTbl from "./FacilityLocationLangDtlsTbl";
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import CircularProgress from '@material-ui/core/CircularProgress';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { validateNPI } from './validateNPI';
import AllLanguages from './AllLanguages';
import WarningIcon from '@material-ui/icons/Warning';

function desc(a, b, orderBy) {
    let c = a[orderBy];
    let d = b[orderBy];

    if (isNotEmpty(c)) {
        if (typeof c === "string") {
            c = c.toUpperCase();
        } else if (c instanceof Date) {
            c = parseDate(c);
        }
    } else {
        c = "";
    }

    if (isNotEmpty(d)) {
        if (typeof d === "string") {
            d = d.toUpperCase();
        } else if (d instanceof Date) {
            d = parseDate(d);
        }
    } else {
        d = "";
    }

    if (d < c) {
        return -1;
    }

    if (d > c) {
        return 1;
    }

    return 0;


}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

// Helper function to format array items as comma-separated string
function formatItems(items) {
    if (!items || !Array.isArray(items) || items.length === 0) {
        return '';
    }

    return items
        .map(item => item.serviceDesc || item.fsrShortDesc || item.specialtyDesc || item.specDesc || item.languageDesc || item.lngLanguageName || item.focusShortDesc || '')
        .filter(Boolean)
        .join(', ');
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

// Helper function to format Y/N to Yes/No for display
function formatYesNo(value) {
    if (value === 'Y') return 'YES';
    if (value === 'N') return 'NO';
    return value; // Return original value if not Y or N
}

// Helper function to extract focus areas from details and format as comma-separated string
// with ellipsis if there are more than 2 focus areas
function formatFocusAreas(details) {
    if (!details || !Array.isArray(details) || details.length === 0) {
        return '';
    }

    const focusAreas = details
        .map(detail => detail.focusShortDesc || '')
        .filter(Boolean);

    if (focusAreas.length <= 2) {
        return focusAreas.join(', ');
    } else {
        return `${focusAreas.slice(0, 2).join(', ')}...`;
    }
}

function formatFocusAreasComplete(details) {
    if (!details || !Array.isArray(details) || details.length === 0) {
        return '';
    }

    return details
        .map(detail => detail.focusShortDesc || '')
        .filter(Boolean)
        .join(', ');
}


const headCells = [
    { id: 'faclocDirectoryLocName', numeric: false, disablePadding: true, label: 'Name', filterLable: ' Name', width: '15%' },
    { id: 'addressString', numeric: false, disablePadding: true, label: 'Address', filterLable: ' Address', width: '20%' },
    { id: 'faclocDirectoryPhoneNbr', numeric: false, disablePadding: true, label: 'Phone', filterLable: 'Phone', width: '10%' },
    { id: 'faclocFaxNbr', numeric: false, disablePadding: true, label: 'Fax ', filterLable: 'Fax ', width: '10%' },
    { id: 'faclocEmailAddress', numeric: false, disablePadding: true, label: 'Email Address', filterLable: 'Email Address', width: '15%' },

    { id: 'flfAcceptWcPatients', numeric: false, disablePadding: true, label: 'Accepting New WC?', filterLable: 'Accepting New WC?', width: '10%' },
    // { id: 'FOCUS', numeric: false, disablePadding: true, label: 'Focus', filterLable: 'Focus', width: '10%' },
    { id: 'Additional Information', numeric: false, disablePadding: true, label: 'Additional Information', filterLable: 'Additional Infor', width: '10%' },
    { id: 'ACTIONS', numeric: false, disablePadding: true, label: 'Actions', filterLable: 'Actions', width: '10%' }
];



function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, onRequestFilter } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };
    const onFilter = property => event => {
        onRequestFilter(event.target.value, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        style={{ width: headCell.width }}
                        autoFocus={headCell.id === 'userFirstName'}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id && headCell.id !== 'ACTIONS'}
                            direction={order}
                            onClick={headCell.id !== 'ACTIONS' ? createSortHandler(headCell.id) : null}
                            disabled={headCell.id === 'ACTIONS'}
                        >
                            <div>
                                <div>
                                    {headCell.label}
                                    {orderBy === headCell.id ? (
                                        <span className={classes.visuallyHidden}>
                                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                        </span>) : null}
                                </div>
                            </div>
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
            <TableRow className='filter-row'>
                {headCells.map(headCell => (
                    <TableCell
                        key={headCell.id + 1}
                        padding="none"
                        style={{ maxWidth: headCell.width, padding: 0 }}
                        autoFocus={headCell.id === 'userFirstName'}
                    >
                        {headCell.id !== 'ACTIONS' && (
                            <div style={{ paddingRight: '0', verticalAlign: 'bottom' }}>
                                <TextField
                                    id={`filter-${headCell.id}`}
                                    fullWidth
                                    autoFocus={headCell.id === 'userFirstName'}
                                    style={{ height: '.7', margin: 0 }}
                                    placeholder="Filter..."
                                    margin="none"
                                    variant="outlined"
                                    size="small"
                                    onChange={onFilter(headCell.id)}
                                    InputProps={{
                                        style: { backgroundColor: 'transparent' }
                                    }}
                                />
                            </div>
                        )}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onRequestFilter: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = () => {
    return ({});
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const useStyles1 = makeStyles(theme => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
}));

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();

    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = event => {
        onChangePage(event, 0);
    };

    const handleBackButtonClick = event => {
        onChangePage(event, page - 1);
    };

    const handleNextButtonClick = event => {
        onChangePage(event, page + 1);
    };

    const handleLastPageButtonClick = event => {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}

const useStyles = theme => ({
    root: {
        width: '100%',
        marginTop: 0,
        maxWidth: '100%',
        padding: 0
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
        maxWidth: '100%',
        padding: 0
    },
    table: {
        minWidth: 450,
        width: '100%',
    },
    tableWrapper: {
        overflowX: 'auto',
        width: '100%',
        maxWidth: '100%',
        padding: 0,
        margin: 0
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    deleted: {
        textDecoration: 'line-through',
        color: '#999',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: '100%',
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(2),
        borderTop: '1px solid #e0e0e0',
        marginTop: 0,
        marginBottom: 0
    },
    actionButton: {
        margin: theme.spacing(0, 1),
        minWidth: '160px', // Ensure buttons have consistent width
    },
});


class FacilityLocationEdit extends Component {
    constructor(props) {
        super(props);
        this.dialogContentRef = React.createRef();
        this.state = {
            page: 0,
            rowsPerPage: 5,
            details: [],
            showDlg: false,
            showEditDlg: false,
            officeName: '',
            filtered: [],
            order: 'asc',
            orderBy: 'faclocDirectoryLocName',
            editLocation: null,
            deletedLocations: [],
            // Track changes
            pristineLocations: [],
            originalLocations: [], // Pristine original data
            workingLocations: [], // Current working copy with all pending changes applied
            changeTracking: [], // Array to track all changes with { action, originalObj, newObj, id }
            hasLocalChanges: false,
            formErrors: {},
            validationMessage: '',
            showConfirmationDialog: false,
            // New state for changes summary dialog
            showChangesSummaryDialog: false,
            changesSummary: {
                newLocations: [],
                modifiedLocations: [],
                deletedLocations: []
            },

            services: [], specialties: [], focuses: [], languages: [],
            filteredServices: [], filteredSpecialties: [], filteredFocuses: [], filteredLanguages: [],

            showDeleteConfirmDialog: false,
            locationToDelete: null,
            countyOptions: [],
            loadingCounties: false,
            expandedFocusRows: {},
            stateOptions: [],
            loadingStates: false,

            // New state properties for the collapsible sections
            serviceOptions: [],
            specialtyOptions: [],
            focusOptions: [],
            languageOptions: [],
            expandedAccordion: null,
            currentTab: 0,
            serviceSearchTerm: '',
            specialtySearchTerm: '',
            focusSearchTerm: '',
            languageSearchTerm: '',
            deletedServices: [],
            deletedSpecialties: [],
            deletedFocuses: [],
            deletedLanguages: [],
        }
        this.handleToggleFocusExpansion = this.handleToggleFocusExpansion.bind(this);
    }




    // Add these methods to handle search input changes
    handleServiceSearchChange = (event) => {
        this.setState({ serviceSearchTerm: event.target.value });
    };

    handleSpecialtySearchChange = (event) => {
        this.setState({ specialtySearchTerm: event.target.value });
    };

    handleFocusSearchChange = (event) => {
        this.setState({ focusSearchTerm: event.target.value });
    };

    handleLanguageSearchChange = (event) => {
        this.setState({ languageSearchTerm: event.target.value });
    };

    getTabIndex = (tabName) => {
        let index = 1; // General tab is always 0

        if (tabName === "Services" && this.state.showServicesTab) {
            return 1;
        }

        if (tabName === "Specialties" && this.state.showSpecialtiesTab) {
            return this.state.showServicesTab ? 2 : 1;
        }

        if (tabName === "Focus Areas" && this.state.showFocusAreasTab) {
            index = 1;
            if (this.state.showServicesTab) index++;
            if (this.state.showSpecialtiesTab) index++;
            return index;
        }

        if (tabName === "Languages") {
            index = 1;
            if (this.state.showServicesTab) index++;
            if (this.state.showSpecialtiesTab) index++;
            if (this.state.showFocusAreasTab) index++;
            return index;
        }

        return -1;
    }
    componentDidMount() {
        const locationsDeepCopy = JSON.parse(JSON.stringify(this.props.locations || []));

        // Determine which sections to show based on facility type and participation types
        const { type, participationTypes } = this.props;

        let showServicesTab = false;
        let showSpecialtiesTab = false;
        let showFocusAreasTab = true; // Default to true

        if (type === "H") {
            // For Hospital type, only show Services and Languages tabs
            showServicesTab = true;
            showSpecialtiesTab = false;
            showFocusAreasTab = false;
        } else if (type === "A") {
            const participationList = participationTypes || [];

            if (participationList.length === 0) {
                // No participation types - show both tabs
                showServicesTab = true;
                showSpecialtiesTab = true;
            } else {
                // Check for specific participation types
                const hasAncillaryType = participationList.some(item =>
                    item && item.toLowerCase().includes('ancillary')
                );

                const hasPhysicianGroupType = participationList.some(item =>
                    item && item.toLowerCase().includes('physician group')
                );

                showServicesTab = hasAncillaryType;
                showSpecialtiesTab = hasPhysicianGroupType;
            }

            showFocusAreasTab = true;
        }

        this.setState({
            pristineLocations: locationsDeepCopy,
            originalLocations: locationsDeepCopy,
            workingLocations: locationsDeepCopy,
            serviceOptions: [],
            specialtyOptions: [],
            focusOptions: [],
            languageOptions: [],
            expandedAccordion: null,
            // Store tab visibility flags
            showServicesTab,
            showSpecialtiesTab,
            showFocusAreasTab
        });
        this.fetchFocusAreas();
        this.fetchStatesAndTerritories();
        if (showServicesTab) {
            this.fetchAllServices();
        }

        if (showSpecialtiesTab) {
            this.fetchAllSpecialties();
        }

        this.fetchAllLanguages();
        // Expose methods to parent via ref
        if (this.props.forwardedRef) {
            this.props.forwardedRef.current = {
                validateForm: () => {
                    return true;
                },
                getFormData: () => {
                    const currentLocations = this.getCurrentLocations();

                    // Generate a summary of changes for the parent
                    const changesSummary = this.generateChangesSummary();

                    return {
                        pristineObject: this.state.pristineLocations,
                        modifiedObject: this.state.hasLocalChanges ? {
                            active: currentLocations,
                            changes: changesSummary
                        } : null,
                        isValid: true
                    };
                }
            };
        }
    }

    fetchAllLanguages = () => {
        this.setState({ loadingLanguages: true });

        try {
            // Use the AllLanguages array directly, focusing only on language names
            const languageOptions = AllLanguages.map(language => ({
                value: language.name,
                label: language.name
            })).sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically

            this.setState({
                languageOptions,
                loadingLanguages: false
            });
        } catch (error) {
            console.error('Error processing languages:', error);
            this.setState({
                languageOptions: [],
                loadingLanguages: false
            });
        }
    };

    fetchAllServices = () => {
        this.setState({ loadingServices: true });

        // Call the service to get all services
        ProviderService.getAllServicesForFacility()
            .then(response => {
                if (response && response.data) {
                    const serviceOptions = response.data.map(service => ({
                        id: service.fsrId,
                        value: service.serviceDesc || service.fsrShortDesc,
                        label: service.serviceDesc || service.fsrShortDesc
                    })).sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically

                    this.setState({
                        serviceOptions,
                        loadingServices: false
                    });
                } else {
                    console.error('No services data returned from service');
                    this.setState({
                        serviceOptions: [],
                        loadingServices: false
                    });
                }
            })
            .catch(error => {

                this.setState({
                    serviceOptions: [],
                    loadingServices: false
                });
            });
    };


    fetchAllSpecialties = () => {
        this.setState({ loadingSpecialties: true });

        // Call the service to get all specialties
        ProviderService.getAllSpecialtyForFacility()
            .then(response => {
                if (response && response.data) {
                    const specialtyOptions = response.data
                        .filter(specialty => specialty.specCvcApprovedFlag === 'Y') // Only include approved specialties
                        .map(specialty => ({
                            id: specialty.specId,
                            value: specialty.specialtyDesc || specialty.specDesc,
                            label: specialty.specialtyDesc || specialty.specDesc
                        }))
                        .sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically

                    this.setState({
                        specialtyOptions,
                        loadingSpecialties: false
                    });
                } else {
                    console.error('No specialties data returned from service');
                    this.setState({
                        specialtyOptions: [],
                        loadingSpecialties: false
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching all specialties:', error);
                this.setState({
                    specialtyOptions: [],
                    loadingSpecialties: false
                });
            });
    };
    fetchFocusAreas = () => {
        this.setState({ loadingFocusAreas: true });

        ProviderService.getFocusAreasForProvider()
            .then(response => {
                if (response && response.data) {
                    // Get all focus areas
                    const allFocusOptions = response.data
                        .map(focus => ({
                            id: focus.focusId,
                            value: focus.focusShortDesc,
                            acronym: focus.focusAcronym || '',
                            label: `${focus.focusShortDesc || ''}`.trim()
                        }))
                        .sort((a, b) => a.label.localeCompare(b.label));

                    // Get the current location's selected focus areas if we're editing
                    const currentLocation = this.state.editLocation;
                    const selectedFocusValues = currentLocation?.focusAreas || [];
                    const deletedFocuses = this.state.deletedFocuses || [];

                    // If we're editing a location, filter out already selected focus areas that aren't deleted
                    let focusOptions = allFocusOptions;
                    if (currentLocation) {
                        focusOptions = allFocusOptions.filter(option => {
                            // Include if it's not selected OR if it's selected but marked as deleted
                            return !selectedFocusValues.includes(option.value) ||
                                (selectedFocusValues.includes(option.value) &&
                                    deletedFocuses.includes(option.value));
                        });
                    }

                    this.setState({
                        focusOptions,
                        loadingFocusAreas: false
                    });
                } else {
                    console.error('No focus areas data returned from service');
                    this.setState({
                        focusOptions: [],
                        loadingFocusAreas: false
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching focus areas:', error);
                this.setState({
                    focusOptions: [],
                    loadingFocusAreas: false,
                });
            });
    }


    fetchLanguages = (flfFaclocId) => {
        if (flfFaclocId && flfFaclocId.toString().startsWith('temp_')) {
            // For new locations, fetch all services instead
            this.fetchAllLanguages();
            return;
        }
        const { prvId } = this.props;
        if (!prvId) {
            console.error('Provider ID is required to fetch languages');
            this.setState({
                languageOptions: [],
                loadingLanguages: false
            });
            return;
        }

        this.setState({ loadingLanguages: true });

        ProviderService.getLanguagesForFacility(prvId, flfFaclocId)
            .then(response => {
                if (response && response.data) {
                    // Get the current location's selected languages
                    const currentLocation = this.state.editLocation;
                    const selectedLanguageValues = currentLocation.selectedLanguages || [];

                    // Filter out languages that are already selected and not deleted
                    const deletedLanguages = this.state.deletedLanguages || [];

                    const languageOptions = response.data
                        .map(language => ({
                            id: language.languageId,
                            value: language.languageDesc || language.lngLanguageName,
                            label: language.languageDesc || language.lngLanguageName
                        }))
                        .filter(option => {
                            // Include if it's not selected OR if it's selected but marked as deleted
                            return !selectedLanguageValues.includes(option.value) ||
                                (selectedLanguageValues.includes(option.value) &&
                                    deletedLanguages.includes(option.value));
                        })
                        .sort((a, b) => a.label.localeCompare(b.label));

                    this.setState({
                        languageOptions,
                        loadingLanguages: false
                    });
                } else {
                    console.error('No languages data returned from service');
                    this.setState({
                        languageOptions: [],
                        loadingLanguages: false
                    });
                }
            })
            .catch(error => {
                console.error(`Error fetching languages for provider ${prvId}:`, error);
                this.setState({
                    languageOptions: [],
                    loadingLanguages: false
                });
            });
    }



    fetchStatesAndTerritories = () => {
        this.setState({ loadingStates: true });

        ProviderService.getStatesAndTerritories()
            .then(response => {
                if (response && response.data) {
                    // Transform the data to include both code and name
                    const stateOptions = response.data.map(record => ({
                        value: record.srStateCode,  // Use the state code as value
                        label: `${record.srStateName} (${record.srStateCode})`  // Format label with name and code
                    }));

                    this.setState({
                        stateOptions: stateOptions,
                        loadingStates: false
                    });
                } else {
                    console.error('No states data returned from service');
                    this.setState({ loadingStates: false });
                }
            })
            .catch(error => {
                console.error('Error fetching states and territories:', error);
                this.setState({ loadingStates: false });
            });
    }

    componentDidUpdate(prevProps) {
        // Check if the locations prop has changed from parent
        if (prevProps.locations !== this.props.locations) {
            console.log('Locations prop changed from parent');

            // Only update original locations if we haven't made local changes
            // This prevents overwriting our tracked changes when parent updates
            if (!this.state.hasLocalChanges) {
                console.log('No local changes, updating original locations');
                const locationsDeepCopy = JSON.parse(JSON.stringify(this.props.locations || []));
                this.setState({
                    originalLocations: locationsDeepCopy,
                    workingLocations: locationsDeepCopy
                });
            } else {
                //console.log('Has local changes, not updating original locations');
            }

            // Always reset to first page when data changes
            this.setState({ page: 0 });
        }

        // Check if filtered locations have changed
        if (prevProps.filtered !== this.props.filtered) {
            //console.log('Filtered locations changed from parent');
            // Reset to first page when filter results change
            this.setState({ page: 0 });
        }
    }


    setFilterServices = (services) => {
        this.setState({ filteredServices: services });

    }
    setFilterSpecialties = (specialties) => {
        this.setState({ filteredSpecialties: specialties });

    }
    setFilterFocuses = (focuses) => {
        this.setState({ filteredFocuses: focuses });

    }
    setFilterLanguages = (languages) => {
        this.setState({ filteredLanguages: languages });
    }



    closeEditDlg = () => {
        this.setState({
            editLocation: null,
            showEditDlg: false,
            formErrors: {},
            validationMessage: '',
            currentTab: 0, // Reset to General tab
            // Reset search terms
            serviceSearchTerm: '',
            specialtySearchTerm: '',
            focusSearchTerm: '',
            languageSearchTerm: ''
        });
    }

    handleRequestSort = (event, property) => {
        const isDesc = this.state.orderBy === property && this.state.order === 'desc';
        this.setState({ order: isDesc ? 'asc' : 'desc', orderBy: property });
    }

    // Track changes to a location
    trackChange = (action, originalObj, newObj, id) => {
        console.log(`Tracking change - Action: ${action}, ID: ${id}`);
        console.log('Original Object:', originalObj);
        console.log('New Object:', newObj);

        this.setState(prevState => {
            // Create a copy of the current change tracking array
            let updatedChangeTracking = [...prevState.changeTracking];

            // Find if we already have a change for this ID
            const existingChangeIndex = updatedChangeTracking.findIndex(
                change => change.id === id
            );

            if (existingChangeIndex !== -1) {
                console.log(`Updating existing change for ID: ${id}`);
                // FIXED: Deep copy the original object to prevent mutation
                updatedChangeTracking[existingChangeIndex] = {
                    action,
                    originalObj: JSON.parse(JSON.stringify(originalObj)), // Deep copy
                    newObj: JSON.parse(JSON.stringify(newObj)), // Deep copy
                    id
                };
            } else {
                console.log(`Adding new change for ID: ${id}`);
                // FIXED: Deep copy both objects
                updatedChangeTracking.push({
                    action,
                    originalObj: JSON.parse(JSON.stringify(originalObj)), // Deep copy
                    newObj: JSON.parse(JSON.stringify(newObj)), // Deep copy
                    id
                });
            }

            console.log('Updated change tracking:', updatedChangeTracking);

            return {
                changeTracking: updatedChangeTracking,
                hasLocalChanges: true
            };
        }, () => {
            // After updating the change tracking, update the displayed locations
            this.updateDisplayedLocations();

            // Notify parent that this section has unsaved changes
            if (this.props.onSectionHasChanges) {
                this.props.onSectionHasChanges(true);
            }
        });
    }


    handleRequestFilter = (value, property) => {
        //console.log('Filter request:', { property, value });

        // Get the locations we should be filtering on
        const locationsToFilter = this.state.hasLocalChanges ?
            this.getCurrentLocations() :
            this.props.locations;

        //console.log('Current locations before filtering:', locationsToFilter);

        if (value.length < 1) {
            // No filter - show all locations
            //console.log('Clearing filter, showing all locations');
            this.props.setFilter(locationsToFilter);
            return true;
        }

        //console.log(`Filtering on property: ${property} with value: ${value}`);

        // Special handling for FOCUS which needs to look at details array
        if (property === 'FOCUS') {
            const filteredLocations = locationsToFilter.filter(location => {
                // Check if location has details with focus areas
                if (!location.details || !Array.isArray(location.details)) {
                    return false;
                }

                // Check if any focus area includes the search term
                return location.details.some(detail => {
                    const focusName = detail.focusName || detail.focusShortDesc || '';
                    return focusName.toUpperCase().includes(value.toUpperCase());
                });
            });

            //console.log(`Found ${filteredLocations.length} locations matching focus filter`);
            this.setState({ page: 0 });
            this.props.setFilter(filteredLocations);
            return true;
        }

        // Standard property filtering
        const filteredLocations = locationsToFilter.filter(location => {
            // Handle nested properties like 'address'
            let propertyValue = location[property];

            // Skip if property doesn't exist
            if (propertyValue === undefined || propertyValue === null) {
                return false;
            }

            // Convert to string and uppercase for case-insensitive comparison
            const testValue = propertyValue.toString().toUpperCase();
            const searchValue = value.toUpperCase();

            // Check if the property value includes the search term
            const matches = testValue.includes(searchValue);

            if (matches) {
                //console.log(`Match found for ${property}: ${testValue} includes ${searchValue}`);
            }

            return matches;
        });

        //console.log(`Filter results: ${filteredLocations.length} locations match criteria`);
        this.setState({ page: 0 });
        this.props.setFilter(filteredLocations);
        return true;
    }



    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage })
    }

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: event.target.value })
    }

    handleViewDetails(services, specialties, focuses, languages, officeName) {
        console.log("View Details - Services:", services);
        console.log("View Details - Specialties:", specialties);
        console.log("View Details - Focuses:", focuses);
        console.log("View Details - Languages:", languages);

        this.setState({
            services: services || [],
            specialties: specialties || [],
            focuses: focuses || [],
            languages: languages || [],
            showDlg: true,
            filteredServices: services || [],
            filteredSpecialties: specialties || [],
            filteredFocuses: focuses || [],
            filteredLanguages: languages || [],
            officeName: officeName
        });
    }

    closeMsgDlg = () => {
        this.setState({ services: [], specialties: [], focuses: [], languages: [], showDlg: false });
    }

    handleAddNewLocation = () => {
        this.setState({ formErrors: {}, validationMessage: '' });
        const today = new Date();
        // Create an empty location object with default values
        const newLocation = {
            flfFaclocId: `temp_${Date.now()}`, // Temporary ID until saved
            faclocDirectoryLocName: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            county: '',
            zip: '',
            zipExt: '',
            faclocDirectoryPhoneNbr: '',
            faclocFaxNbr: '',
            faxExt: '',
            faclocEmailAddress: '',
            ptcTaxId: '',
            flfAcceptWcPatients: '',
            flfAcceptWcPatDate: today,
            focusAreas: [],
            details: [],
            // Initialize these arrays to prevent the error
            services: [],
            specialties: [],
            focuses: [],
            languages: [],
            selectedServices: [],
            selectedSpecialties: [],
            selectedLanguages: [],
            isNew: true
        };

        this.setState({
            editLocation: newLocation,
            showEditDlg: true,
            countyOptions: [], // Clear county options for new locations
            // Reset deleted items arrays
            deletedServices: [],
            deletedSpecialties: [],
            deletedFocuses: [],
            deletedLanguages: [],
            currentTab: 0 // Reset to General tab
        });
    };

    fetchServices = (flfFaclocId) => {
        if (flfFaclocId && flfFaclocId.toString().startsWith('temp_')) {
            // For new locations, fetch all services instead
            this.fetchAllServices();
            return;
        }
        const { prvId } = this.props;
        if (!prvId) {
            console.error('Provider ID is required to fetch services');
            this.setState({
                serviceOptions: [],
                loadingServices: false
            });
            return;
        }

        this.setState({ loadingServices: true });

        ProviderService.getServicesForFacility(prvId, flfFaclocId)
            .then(response => {
                if (response && response.data) {
                    // Get the current location's selected services
                    const currentLocation = this.state.editLocation;
                    const selectedServiceValues = currentLocation.selectedServices || [];

                    // Filter out services that are already selected
                    const serviceOptions = response.data
                        .map(service => ({
                            id: service.fsrId,
                            value: service.serviceDesc || service.fsrShortDesc,
                            label: service.serviceDesc || service.fsrShortDesc
                        }))
                        .filter(option => !selectedServiceValues.includes(option.value))
                        .sort((a, b) => {
                            // Case-insensitive alphabetical sort
                            return (a.label || '').toString().localeCompare((b.label || '').toString(), undefined, { sensitivity: 'base' });
                        });

                    this.setState({
                        serviceOptions,
                        loadingServices: false
                    });
                } else {
                    console.error('No services data returned from service');
                    this.setState({
                        serviceOptions: [],
                        loadingServices: false
                    });
                }
            })
            .catch(error => {
                console.error(`Error fetching services for provider ${prvId}:`, error);
                this.setState({
                    serviceOptions: [],
                    loadingServices: false
                });
            });
    }

    fetchSpecialties = (flfFaclocId) => {
        if (flfFaclocId && flfFaclocId.toString().startsWith('temp_')) {
            // For new locations, fetch all services instead
            this.fetchAllSpecialties();
            return;
        }
        const { prvId } = this.props;
        if (!prvId) {
            console.error('Provider ID is required to fetch specialties');
            this.setState({
                specialtyOptions: [],
                loadingSpecialties: false
            });
            return;
        }

        this.setState({ loadingSpecialties: true });

        ProviderService.getSpecialtiesForFacility(prvId, flfFaclocId)
            .then(response => {
                if (response && response.data) {
                    // Get the current location's selected specialties
                    const currentLocation = this.state.editLocation;
                    const selectedSpecialtyValues = currentLocation.selectedSpecialties || [];

                    // Filter out specialties that are already selected
                    const specialtyOptions = response.data
                        .map(specialty => ({
                            id: specialty.specId,
                            value: specialty.specialtyDesc || specialty.specDesc,
                            label: specialty.specialtyDesc || specialty.specDesc
                        }))
                        .filter(option => !selectedSpecialtyValues.includes(option.value));

                    this.setState({
                        specialtyOptions,
                        loadingSpecialties: false
                    });
                } else {
                    console.error('No specialties data returned from service');
                    this.setState({
                        specialtyOptions: [],
                        loadingSpecialties: false
                    });
                }
            })
            .catch(error => {
                console.error(`Error fetching specialties for provider ${prvId}:`, error);
                this.setState({
                    specialtyOptions: [],
                    loadingSpecialties: false
                });
            });
    }

    hasTabErrors = (tabName) => {
        const { formErrors } = this.state;
        if (!formErrors || Object.keys(formErrors).length === 0) return false;

        switch (tabName) {
            case "General":
                return [
                    'faclocDirectoryLocName', 'faclocNpi', 'address1', 'address2', 'city',
                    'state', 'county', 'zip', 'zipExt', 'faclocDirectoryPhoneNbr',
                    'faclocFaxNbr', 'faxExt', 'faclocEmailAddress', 'flfAcceptWcPatients'
                ].some(field => formErrors[field]);

            case "Services":
                return formErrors.services !== undefined;

            case "Specialties":
                return formErrors.specialties !== undefined;

            case "Focus Areas":
                return formErrors.focusAreas !== undefined || formErrors.details !== undefined;

            case "Languages":
                return formErrors.languages !== undefined;

            default:
                return false;
        }
    };

    handleTabChange = (event, newValue) => {
        // Allow tab switching without validation checks
        this.setState({
            currentTab: newValue
        });

    };

    hasPhysicianGroupParticipation = () => {
        const { participationTypes } = this.props;
        if (!participationTypes || !Array.isArray(participationTypes)) return false;

        return participationTypes.some(item =>
            item && item.toLowerCase().includes('physician group')
        );
    }
    validateServiceOrSpecialty = (selectedServices, deletedServices, selectedSpecialties, deletedSpecialties) => {
        const participationList = this.props.participationTypes || [];
        const hasNoParticipationTypes = participationList.length === 0;

        // Calculate active items
        const activeServices = (selectedServices || []).filter(
            service => !(deletedServices || []).includes(service)
        );

        const activeSpecialties = (selectedSpecialties || []).filter(
            specialty => !(deletedSpecialties || []).includes(specialty)
        );

        // For no participation types: require at least one service OR one specialty
        if (hasNoParticipationTypes && this.props.type === "A") {
            if (this.state.showServicesTab && this.state.showSpecialtiesTab &&
                activeServices.length === 0 && activeSpecialties.length === 0) {
                return {
                    hasError: true,
                    serviceError: "At least one Service or Specialty is required",
                    specialtyError: "At least one Service or Specialty is required",
                    validationMessage: "Please select at least one Service or Specialty"
                };
            }
        }

        // No error for combined validation
        return { hasError: false };
    }
    checkServiceRequirements = (selectedServices, deletedServices) => {
        // Skip validation if tab isn't shown
        if (!this.state.showServicesTab) {
            return { hasError: false };
        }

        // For Hospital type or Ancillary with Ancillary participation: require service
        if (this.props.type === "H" ||
            (this.props.type === "A" && this.hasAncillaryParticipation())) {

            const activeServices = (selectedServices || []).filter(
                service => !(deletedServices || []).includes(service)
            );

            if (activeServices.length === 0) {
                return {
                    hasError: true,
                    serviceError: "Service is required.",
                    validationMessage: "Service is required"
                };
            }
        }

        // No error
        return { hasError: false };
    };

    checkSpecialtyRequirements = (selectedSpecialties, deletedSpecialties) => {
        // Skip validation if tab isn't shown
        if (!this.state.showSpecialtiesTab) {
            return { hasError: false };
        }

        // For Ancillary with Physician Group participation: require specialty
        if (this.props.type === "A" && this.hasPhysicianGroupParticipation()) {
            const activeSpecialties = (selectedSpecialties || []).filter(
                specialty => !(deletedSpecialties || []).includes(specialty)
            );

            if (activeSpecialties.length === 0) {
                return {
                    hasError: true,
                    specialtyError: "Specialty is required for Physician Group participation.",
                    validationMessage: "Specialty is required"
                };
            }
        }

        // No error
        return { hasError: false };
    };

    // Helper method to check for Ancillary participation
    hasAncillaryParticipation = () => {
        const { participationTypes } = this.props;
        if (!participationTypes || !Array.isArray(participationTypes)) return false;

        return participationTypes.some(item =>
            item && item.toLowerCase().includes('ancillary')
        );
    }

    findFirstTabWithErrors = (errors) => {
        // Define which fields belong to which tabs
        const generalTabFields = [
            'faclocDirectoryLocName', 'faclocNpi', 'address1', 'address2', 'city',
            'state', 'county', 'zip', 'zipExt', 'faclocDirectoryPhoneNbr',
            'faclocFaxNbr', 'faxExt', 'faclocEmailAddress', 'flfAcceptWcPatients'
        ];

        const servicesTabFields = ['services'];
        const specialtiesTabFields = ['specialties'];
        const focusAreasTabFields = ['focusAreas', 'details'];
        const languagesTabFields = ['languages'];

        // Check if any general tab fields have errors
        if (generalTabFields.some(field => errors[field])) {
            return 0; // General tab index is always 0
        }

        // Check services tab (if visible)
        if (this.state.showServicesTab &&
            servicesTabFields.some(field => errors[field])) {
            return this.getTabIndex("Services");
        }

        // Check specialties tab (if visible)
        if (this.state.showSpecialtiesTab &&
            specialtiesTabFields.some(field => errors[field])) {
            return this.getTabIndex("Specialties");
        }

        // Check focus areas tab (if visible)
        if (this.state.showFocusAreasTab &&
            focusAreasTabFields.some(field => errors[field])) {
            return this.getTabIndex("Focus Areas");
        }

        // Check languages tab (always visible)
        if (languagesTabFields.some(field => errors[field])) {
            return this.getTabIndex("Languages");
        }

        // Default to current tab if no errors found
        return this.state.currentTab;
    };

    // Helper function to format date for display


    handleEditLocation = (location) => {
        this.setState({ formErrors: {}, validationMessage: '' });

        // Get the most up-to-date version of this location from our current locations
        const currentLocations = this.getCurrentLocations();
        const currentLocation = currentLocations.find(loc => loc.flfFaclocId === location.flfFaclocId);

        if (!currentLocation) {
            console.error(`Could not find location with ID ${location.flfFaclocId} in current locations`);
            return;
        }

        // Make a deep copy to avoid reference issues
        const locationToEdit = JSON.parse(JSON.stringify(currentLocation));

        // Parse fax extension if exists
        let faxNumber = locationToEdit.faclocFaxNbr || '';
        let faxExt = '';
        if (faxNumber.includes('ext')) {
            const faxParts = faxNumber.split('ext');
            faxNumber = faxParts[0].trim();
            faxExt = faxParts[1].trim();
        }

        // Parse focus areas from details if available
        let focusAreas = [];
        if (location.details && Array.isArray(location.details)) {
            focusAreas = location.details.map(detail =>
                typeof detail === 'object' ? (detail.focusShortDesc || detail.focusName || detail.value) : detail
            ).filter(Boolean);
        }

        // Extract services from the location data - handle different possible formats
        let selectedServices = [];
        if (location.services && Array.isArray(location.services)) {
            selectedServices = location.services.map(service => {
                if (typeof service === 'string') {
                    return service;
                }
                return service.serviceDesc ||
                    service.fsrShortDesc ||
                    service.value ||
                    '';
            }).filter(Boolean);
        }

        // Extract specialties from the location data - handle different possible formats
        let selectedSpecialties = [];
        if (location.specialties && Array.isArray(location.specialties)) {
            selectedSpecialties = location.specialties.map(specialty => {
                if (typeof specialty === 'string') {
                    return specialty;
                }
                return specialty.specialtyDesc ||
                    specialty.specDesc ||
                    specialty.value ||
                    '';
            }).filter(Boolean);
        }

        // Extract languages from the location data
        let selectedLanguages = [];
        if (location.languages && Array.isArray(location.languages)) {
            selectedLanguages = location.languages.map(language => {
                if (typeof language === 'string') {
                    return language;
                }
                return language.languageDesc ||
                    language.lngLanguageName ||
                    language.value ||
                    '';
            }).filter(Boolean);
        }

        // Convert Y/N to YES/NO for the accepting patients flag
        let acceptingWcPatients = locationToEdit.flfAcceptWcPatients || '';
        if (acceptingWcPatients === 'Y') acceptingWcPatients = 'YES';
        if (acceptingWcPatients === 'N') acceptingWcPatients = 'NO';

        // Store the current value BEFORE clearing it
        const currentAcceptingWcValue = acceptingWcPatients;

        const hasBeenModified = this.state.changeTracking.some(
            change => change.id === location.flfFaclocId && (change.action === 'edit' || change.action === 'add')
        );

        // Determine helper text based on whether it's been modified before
        let wcPatientsHelperText = '';
        if (!currentAcceptingWcValue || currentAcceptingWcValue.trim() === '') {
            wcPatientsHelperText = 'This field is required. Please select Yes or No.';
        } else if (hasBeenModified) {
            // Already modified - show previous value
            wcPatientsHelperText = `Previous value was ${currentAcceptingWcValue}. Please verify your selection.`;
        }

        console.log('Has Been Modified Before:', hasBeenModified);
        console.log('Current Accepting WC Value:', currentAcceptingWcValue);
        console.log('Helper Text:', wcPatientsHelperText);

        // Check if this is a new location (has temporary ID)
        const isNewLocation = locationToEdit.isNew ||
            (locationToEdit.flfFaclocId &&
                locationToEdit.flfFaclocId.toString().startsWith('temp_'));

        // Store selected items in state for filtering
        const editLocationState = {
            ...locationToEdit,
            address1: locationToEdit.addressComponents?.address1 || '',
            address2: locationToEdit.addressComponents?.address2 || '',
            city: locationToEdit.addressComponents?.city || '',
            state: locationToEdit.addressComponents?.state || '',
            county: locationToEdit.addressComponents?.county || '',
            zip: locationToEdit.addressComponents?.zip || '',
            zipExt: locationToEdit.addressComponents?.zipExt || '',
            faclocFaxNbr: faxNumber,
            faxExt,
            focusAreas: focusAreas,
            selectedServices: selectedServices,
            selectedSpecialties: selectedSpecialties,
            selectedLanguages: selectedLanguages,
            flfAcceptWcPatients: hasBeenModified ? acceptingWcPatients : '',
            currentAcceptingWcValue: currentAcceptingWcValue, // Store current value
            wcPatientsHelperText: wcPatientsHelperText, // Store helper text
            isNew: locationToEdit.isNew
        };

        // Check if we have stored address components from a previous edit
        if (locationToEdit.addressComponents) {
            this.setState({
                editLocation: editLocationState,
                showEditDlg: true,
                expandedAccordion: null,
                deletedServices: [],
                deletedSpecialties: [],
                deletedFocuses: [],
                deletedLanguages: []
            }, () => {
                // After state is updated, fetch available options based on whether this is a new or existing location
                if (isNewLocation) {
                    console.log('Fetching all options for new location');
                    this.fetchAllServicesForNewLocation(selectedServices);
                    this.fetchAllSpecialtiesForNewLocation(selectedSpecialties);
                    this.fetchFocusAreasForNewLocation(focusAreas);
                    this.fetchAllLanguagesForNewLocation(selectedLanguages);
                } else {
                    console.log('Fetching options for existing location');
                    this.fetchServices(location.flfFaclocId);
                    this.fetchSpecialties(location.flfFaclocId);
                    this.fetchLanguages(location.flfFaclocId);
                }

                if (locationToEdit.addressComponents.state) {
                    this.fetchCountiesForState(locationToEdit.addressComponents.state);
                }

                this.filterAvailableOptions();
            });
        } else {
            // No stored address components, set up with empty address fields
            this.setState({
                editLocation: editLocationState,
                showEditDlg: true,
                expandedAccordion: null,
                deletedServices: [],
                deletedSpecialties: [],
                deletedFocuses: [],
                deletedLanguages: []
            }, () => {
                // After state is updated, fetch available options based on whether this is a new or existing location
                if (isNewLocation) {
                    console.log('Fetching all options for new location');
                    this.fetchAllServicesForNewLocation(selectedServices);
                    this.fetchAllSpecialtiesForNewLocation(selectedSpecialties);
                    this.fetchFocusAreasForNewLocation(focusAreas);
                    this.fetchAllLanguagesForNewLocation(selectedLanguages);
                } else {
                    console.log('Fetching options for existing location');
                    this.fetchServices(location.flfFaclocId);
                    this.fetchSpecialties(location.flfFaclocId);
                    this.fetchLanguages(location.flfFaclocId);
                }

                this.filterAvailableOptions();
            });

            // Fetch address data from server for existing locations
            if (!isNewLocation) {
                const addressId = locationToEdit.faclocDirectoryAddId;
                if (addressId) {
                    ProviderService.getAddressById(addressId)
                        .then((response) => {
                            if (isNotEmpty(response.data)) {
                                const data = response.data;

                                const addressComponents = {
                                    address1: data.addStreet1 || '',
                                    address2: data.addStreet2 || '',
                                    city: data.addCity || '',
                                    state: data.addState || '',
                                    county: data.addCounty || '',
                                    zip: data.addZipCode || '',
                                    zipExt: data.addZipPlusFour || ''
                                };

                                // Update the location in our working locations with the address components
                                const updatedLocations = this.getCurrentLocations().map(loc => {
                                    if (loc.flfFaclocId === locationToEdit.flfFaclocId) {
                                        return {
                                            ...loc,
                                            addressComponents: addressComponents
                                        };
                                    }
                                    return loc;
                                });

                                // Update state with the address data once it's available
                                this.setState(prevState => ({
                                    editLocation: {
                                        ...prevState.editLocation,
                                        ...addressComponents
                                    },
                                    workingLocations: updatedLocations
                                }), () => {
                                    // After state is updated, fetch counties if state has a value
                                    if (data.addState) {
                                        this.fetchCountiesForState(data.addState);
                                    }

                                    // Update parent component with the updated locations that include address components
                                    if (this.props.updateLocations) {
                                        this.props.updateLocations(updatedLocations);
                                    }
                                });
                            } else {
                                console.log('No address data found');
                            }
                        })
                        .catch((error) => {
                            console.log('Error GETTING THE PROVIDERS: ' + error);
                        });
                } else {
                    console.log('No address ID available, cannot fetch address data');
                }
            }
        }
    }

    // New method to fetch all services and filter out already selected ones for new locations
    fetchAllServicesForNewLocation = (selectedServices) => {
        this.setState({ loadingServices: true });

        // Call the service to get all services
        ProviderService.getAllServicesForFacility()
            .then(response => {
                if (response && response.data) {
                    // Get all service options
                    const allServiceOptions = response.data.map(service => ({
                        id: service.fsrId,
                        value: service.serviceDesc || service.fsrShortDesc,
                        label: service.serviceDesc || service.fsrShortDesc
                    })).sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically

                    // Filter out already selected services
                    const serviceOptions = allServiceOptions.filter(option =>
                        !selectedServices.includes(option.value)
                    );

                    this.setState({
                        serviceOptions,
                        loadingServices: false
                    });
                } else {
                    console.error('No services data returned from service');
                    this.setState({
                        serviceOptions: [],
                        loadingServices: false
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching all services:', error);
                this.setState({
                    serviceOptions: [],
                    loadingServices: false
                });
            });
    };

    // New method to fetch all specialties and filter out already selected ones for new locations
    fetchAllSpecialtiesForNewLocation = (selectedSpecialties) => {
        this.setState({ loadingSpecialties: true });

        // Call the service to get all specialties
        ProviderService.getAllSpecialtyForFacility()
            .then(response => {
                if (response && response.data) {
                    // Get all specialty options, filtering by specCvcApprovedFlag
                    const allSpecialtyOptions = response.data
                        .filter(specialty => specialty.specCvcApprovedFlag === 'Y') // Only include approved specialties
                        .map(specialty => ({
                            id: specialty.specId,
                            value: specialty.specialtyDesc || specialty.specDesc,
                            label: specialty.specialtyDesc || specialty.specDesc
                        }))
                        .sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically

                    // Filter out already selected specialties
                    const specialtyOptions = allSpecialtyOptions.filter(option =>
                        !selectedSpecialties.includes(option.value)
                    );

                    this.setState({
                        specialtyOptions,
                        loadingSpecialties: false
                    });
                } else {
                    console.error('No specialties data returned from service');
                    this.setState({
                        specialtyOptions: [],
                        loadingSpecialties: false
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching all specialties:', error);
                this.setState({
                    specialtyOptions: [],
                    loadingSpecialties: false
                });
            });
    };

    // New method to fetch all focus areas and filter out already selected ones for new locations
    fetchFocusAreasForNewLocation = (selectedFocuses) => {
        this.setState({ loadingFocusAreas: true });

        ProviderService.getFocusAreasForProvider()
            .then(response => {
                if (response && response.data) {
                    // Get all focus area options
                    const allFocusOptions = response.data
                        .map(focus => ({
                            id: focus.focusId,
                            value: focus.focusShortDesc,
                            acronym: focus.focusAcronym || '',
                            label: `${focus.focusShortDesc || ''}`.trim()
                        }))
                        .sort((a, b) => a.label.localeCompare(b.label));

                    // Filter out already selected focus areas
                    const focusOptions = allFocusOptions.filter(option =>
                        !selectedFocuses.includes(option.value)
                    );

                    this.setState({
                        focusOptions,
                        loadingFocusAreas: false
                    });
                } else {
                    console.error('No focus areas data returned from service');
                    this.setState({
                        focusOptions: [],
                        loadingFocusAreas: false
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching focus areas:', error);
                this.setState({
                    focusOptions: [],
                    loadingFocusAreas: false,
                });
            });
    };

    // New method to fetch all languages and filter out already selected ones for new locations
    fetchAllLanguagesForNewLocation = (selectedLanguages) => {
        this.setState({ loadingLanguages: true });

        try {
            // Use the AllLanguages array directly, focusing only on language names
            const allLanguageOptions = AllLanguages.map(language => ({
                value: language.name,
                label: language.name
            })).sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically

            // Filter out already selected languages
            const languageOptions = allLanguageOptions.filter(option =>
                !selectedLanguages.includes(option.value)
            );

            this.setState({
                languageOptions,
                loadingLanguages: false
            });
        } catch (error) {
            console.error('Error processing languages:', error);
            this.setState({
                languageOptions: [],
                loadingLanguages: false
            });
        }
    };
    // Add this new helper method to filter available options
    filterAvailableOptions = () => {
        this.setState(prevState => {
            // Get selected values
            const selectedServices = prevState.editLocation.selectedServices || [];
            const selectedSpecialties = prevState.editLocation.selectedSpecialties || [];
            const selectedLanguages = prevState.editLocation.selectedLanguages || [];
            const selectedFocuses = prevState.editLocation.focusAreas || [];
            const deletedServices = prevState.deletedServices || [];
            const deletedSpecialties = prevState.deletedSpecialties || [];
            const deletedLanguages = prevState.deletedLanguages || [];
            const deletedFocuses = prevState.deletedFocuses || [];

            // Filter out selected items from available options
            const filteredServiceOptions = prevState.serviceOptions
                .filter(option => {
                    return !selectedServices.includes(option.value) ||
                        (selectedServices.includes(option.value) &&
                            deletedServices.includes(option.value));
                });

            const filteredSpecialtyOptions = prevState.specialtyOptions
                .filter(option => {
                    return !selectedSpecialties.includes(option.value) ||
                        (selectedSpecialties.includes(option.value) &&
                            deletedSpecialties.includes(option.value));
                });

            const filteredLanguageOptions = prevState.languageOptions
                .filter(option => {
                    return !selectedLanguages.includes(option.value) ||
                        (selectedLanguages.includes(option.value) &&
                            deletedLanguages.includes(option.value));
                });

            const filteredFocusOptions = prevState.focusOptions
                .filter(option => {
                    return !selectedFocuses.includes(option.value) ||
                        (selectedFocuses.includes(option.value) &&
                            deletedFocuses.includes(option.value));
                });

            return {
                serviceOptions: filteredServiceOptions,
                specialtyOptions: filteredSpecialtyOptions,
                languageOptions: filteredLanguageOptions,
                focusOptions: filteredFocusOptions
            };
        });
    }



    // Modified to show confirmation dialog first and fetch address data
    handleConfirmDeleteLocation = (locationId) => {
        console.log(`Confirming deletion for location ${locationId}`);

        // Find the location to delete
        const currentLocations = this.getCurrentLocations();
        const activeLocations = currentLocations.filter(loc => !this.isLocationDeleted(loc.flfFaclocId));

        // If this is the last location, show warning instead of delete confirmation
        if (activeLocations.length === 1 && activeLocations[0].flfFaclocId === locationId) {
            // Show warning popup that last location cannot be deleted
            this.setState({
                showLastLocationWarning: true
            });
            return;
        }
        const locationToDelete = currentLocations.find(loc => loc.flfFaclocId === locationId);

        if (!locationToDelete) {
            console.error(`Could not find location with ID ${locationId} to delete`);
            return;
        }

        // Check if this is a newly added location
        const isNewLocation = locationToDelete.isNew ||
            !this.state.originalLocations.some(loc => loc.flfFaclocId === locationId);

        // For newly added locations, we already have complete data
        if (isNewLocation) {
            this.setState({
                showDeleteConfirmDialog: true,
                locationToDelete: locationToDelete,
                isNewLocationToDelete: isNewLocation
            });
            return;
        }

        // For existing locations, always fetch address data to ensure we have complete information
        const addressId = locationToDelete.ofcDirectoryAddId;

        // Show loading state if needed
        this.setState({ loadingDeleteAddress: true });

        if (addressId) {
            console.log(`Fetching address data for deletion, ID: ${addressId}`);

            ProviderService.getAddressById(addressId)
                .then((response) => {
                    if (isNotEmpty(response.data)) {
                        const data = response.data;
                        console.log('Address data loaded for deletion:', data);

                        // Create address components object
                        const addressComponents = {
                            address1: data.addStreet1 || '',
                            address2: data.addStreet2 || '',
                            city: data.addCity || '',
                            state: data.addState || '',
                            county: data.addCounty || '',
                            zip: data.addZipCode || '',
                            zipExt: data.addZipPlusFour || ''
                        };

                        // Update the location with address components
                        const updatedLocationToDelete = {
                            ...locationToDelete,
                            addressComponents: addressComponents
                        };

                        // Store this updated location in all our working locations to ensure consistency
                        const updatedLocations = this.getCurrentLocations().map(loc => {
                            if (loc.flfFaclocId === locationId) {
                                return updatedLocationToDelete;
                            }
                            return loc;
                        });

                        // Update state and show confirmation dialog
                        this.setState({
                            workingLocations: updatedLocations,
                            showDeleteConfirmDialog: true,
                            locationToDelete: updatedLocationToDelete,
                            loadingDeleteAddress: false,
                            isNewLocationToDelete: isNewLocation
                        }, () => {
                            // Update parent component with the updated locations
                            if (this.props.updateLocations) {
                                this.props.updateLocations(updatedLocations);
                            }
                        });
                    } else {
                        console.log('No address data found for deletion');
                        // Proceed with deletion anyway, using the location as is
                        this.setState({
                            showDeleteConfirmDialog: true,
                            locationToDelete: locationToDelete,
                            loadingDeleteAddress: false,
                            isNewLocationToDelete: isNewLocation
                        });
                    }
                })
                .catch((error) => {
                    console.log('Error getting address for deletion: ' + error);
                    // Proceed with deletion anyway, using the location as is
                    this.setState({
                        showDeleteConfirmDialog: true,
                        locationToDelete: locationToDelete,
                        loadingDeleteAddress: false,
                        isNewLocationToDelete: isNewLocation
                    });
                });
        } else {
            // No address ID available, proceed with deletion using the location as is
            console.log('No address ID available for deletion, cannot fetch address data');
            this.setState({
                showDeleteConfirmDialog: true,
                locationToDelete: locationToDelete,
                loadingDeleteAddress: false,
                isNewLocationToDelete: isNewLocation
            });
        }
    }

    handleCancelDelete = () => {
        this.setState({
            showDeleteConfirmDialog: false,
            locationToDelete: null
        });
    }


    handleUndoDelete = (locationId) => {
        //console.log(`Undoing deletion for location ${locationId}`);

        // Remove this location from change tracking if it was marked for deletion
        this.setState(prevState => {
            const updatedChangeTracking = prevState.changeTracking.filter(
                change => !(change.id === locationId && change.action === 'delete')
            );

            return {
                changeTracking: updatedChangeTracking,
                // Only set hasLocalChanges to false if there are no more changes
                hasLocalChanges: updatedChangeTracking.length > 0
            };
        }, () => {
            // Update the displayed locations after undoing the deletion
            this.updateDisplayedLocations();

            // Notify parent that this section has changes (or no changes)
            if (this.props.onSectionHasChanges) {
                this.props.onSectionHasChanges(this.state.changeTracking.length > 0);
            }
        });
    }

    // Update isLocationDeleted to check the change tracking array
    isLocationDeleted = (locationId) => {
        if (!locationId) return false;

        return this.state.changeTracking.some(
            change => change.id === locationId && change.action === 'delete'
        );
    }

    /*   isNewAndDeleted = (locationId) => {
          if (!locationId) return false;
     
          // Check if this location was added and then deleted
          const addChange = this.state.changeTracking.find(
              change => change.id === locationId && change.action === 'add'
          );
     
          const deleteChange = this.state.changeTracking.find(
              change => change.id === locationId && change.action === 'delete'
          );
     
          // If it was both added and deleted, it should be removed completely
          return addChange && deleteChange;
      } */

    // FIXED: Update the displayed locations and sync with parent
    updateDisplayedLocations = () => {
        //console.log('Updating displayed locations');

        // Get current locations with all changes applied
        let currentLocations = this.getCurrentLocations();
        //console.log('Current locations after applying changes:', currentLocations);

        // Update our working locations
        this.setState({ workingLocations: currentLocations }, () => {
            // Update the parent's filtered data with ALL current locations
            if (this.props.setFilter) {
                //console.log('Updating parent filtered data');
                this.props.setFilter(currentLocations);
            }

            // Also update the parent's main locations data to include new items
            if (this.props.updateLocations) {
                //console.log('Updating parent main locations data');
                this.props.updateLocations(currentLocations);
            }
        });
    }

    formatPhoneNumber = (phoneNumberString) => {
        // Strip all non-digit characters
        let cleaned = ('' + phoneNumberString).replace(/\D/g, '');

        // Limit to 10 digits
        cleaned = cleaned.substring(0, 10);

        // Format as (XXX) XXX-XXXX
        let formatted = cleaned;
        if (cleaned.length > 0) {
            if (cleaned.length <= 3) {
                formatted = `(${cleaned}`;
            } else if (cleaned.length <= 6) {
                formatted = `(${cleaned.substring(0, 3)}) ${cleaned.substring(3)}`;
            } else {
                formatted = `(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
            }
        }

        return formatted;
    }

    // Updated method to fetch counties when state changes
    fetchCountiesForState = (stateId) => {
        if (!stateId) {
            this.setState({ countyOptions: [] });
            return;
        }

        this.setState({ loadingCounties: true });

        ProviderService.getCountiesForState(stateId)
            .then(response => {
                if (response && response.data && Array.isArray(response.data)) {
                    // Handle the simple array of county names
                    const countyOptions = response.data.map(countyName => ({
                        value: countyName,
                        label: countyName
                    }));

                    this.setState({
                        countyOptions: countyOptions,
                        loadingCounties: false
                    });
                } else {
                    console.error('No county data returned from service or invalid format');
                    this.setState({
                        countyOptions: [],
                        loadingCounties: false
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching counties:', error);
                this.setState({
                    countyOptions: [],
                    loadingCounties: false
                });
            });
    }

    // Handle state field input (auto uppercase) without validation
    handleStateInputChange = (e) => {
        const { name, value } = e.target;

        // Update the state field in the form
        this.setState(prevState => ({
            editLocation: {
                ...prevState.editLocation,
                [name]: value,
                // Clear county when state changes
                county: ''
            }
        }), () => {
            // After state is updated, fetch counties if state has a value
            if (name === 'state' && value) {
                this.fetchCountiesForState(value);
            }
        });
    }

    handleCountyChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            editLocation: {
                ...prevState.editLocation,
                [name]: value
            }
        }));
    }

    // Handle phone number input with formatting but no validation
    handlePhoneInputChange = (e) => {
        const { name, value } = e.target;
        const formattedValue = this.formatPhoneNumber(value);

        this.setState(prevState => ({
            editLocation: {
                ...prevState.editLocation,
                [name]: formattedValue
            }
        }));
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            editLocation: {
                ...prevState.editLocation,
                [name]: value
            }
        }));
    }

    /*    handleMultiSelectChange = (field, newValues) => {
           this.setState(prevState => ({
               editLocation: {
                   ...prevState.editLocation,
                   [field]: newValues
               }
           }));
       } */

    handleToggleFocusExpansion(rowId, event) {
        // Prevent the click from propagating to parent elements
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        var self = this; // Store reference to 'this'
        this.setState(function (prevState) {
            var updatedRows = Object.assign({}, prevState.expandedFocusRows);
            updatedRows[rowId] = !prevState.expandedFocusRows[rowId];

            return {
                expandedFocusRows: updatedRows
            };
        });
    }

    validateLocation = (location) => {
        const errors = {};

        // Office Name validation (required)
        if (!location.faclocDirectoryLocName || location.faclocDirectoryLocName.trim() === '') {
            errors.faclocDirectoryLocName = 'Office name is required';
        }

        // Address validation (required with components)
        if (!location.address1 || location.address1.trim() === '') {
            errors.address1 = 'Street address is required';
        }

        if (!location.city || location.city.trim() === '') {
            errors.city = 'City is required';
        }

        if (!location.state || location.state.trim() === '') {
            errors.state = 'State is required';
        }


        if (!location.zip || location.zip.trim() === '') {
            errors.zip = 'ZIP code is required';
        } else if (!/^\d{5}$/.test(location.zip.trim())) {
            errors.zip = 'ZIP code must be 5 digits';
        }

        // ZIP extension validation (optional but must be valid if provided)
        if (location.zipExt && !/^\d{4}$/.test(location.zipExt.trim())) {
            errors.zipExt = 'ZIP extension must be 4 digits';
        }

        // Phone validation (required, 10 digits)
        if (!location.faclocDirectoryPhoneNbr || location.faclocDirectoryPhoneNbr.trim() === '') {
            errors.faclocDirectoryPhoneNbr = 'Phone number is required';
        } else {
            // Remove any non-digit characters for validation
            const phoneDigits = location.faclocDirectoryPhoneNbr.replace(/\D/g, '');
            if (phoneDigits.length !== 10) {
                errors.faclocDirectoryPhoneNbr = 'Phone number must be 10 digits';
            }
        }

        // Fax validation (optional but must be valid if provided)
        if (location.faclocFaxNbr && location.faclocFaxNbr.trim() !== '') {
            // Remove any non-digit characters for validation
            const faxDigits = location.faclocFaxNbr.replace(/\D/g, '');
            if (faxDigits.length !== 10) {
                errors.faclocFaxNbr = 'Fax number must be 10 digits';
            }
        }

        // Fax extension validation (optional but must be valid if provided)
        if (location.faxExt && !/^\d+$/.test(location.faxExt.trim())) {
            errors.faxExt = 'Fax extension must contain only digits';
        }

        // Email validation (optional but must be valid if provided)
        if (location.faclocEmailAddress && location.faclocEmailAddress.trim() !== '') {
            // Basic email validation regex
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(location.faclocEmailAddress.trim())) {
                errors.faclocEmailAddress = 'Please enter a valid email address';
            }
        }

        // Accepting New WC Patients validation (required)
        if (!location.flfAcceptWcPatients || !['YES', 'NO'].includes(location.flfAcceptWcPatients)) {
            errors.flfAcceptWcPatients = 'Please select Yes or No';
        }

        if (location.faclocNpi && location.faclocNpi.trim() !== '') {
            const npiValidation = validateNPI(location.faclocNpi);
            if (npiValidation.status === 'FAIL') {
                errors.faclocNpi = npiValidation.message;
            }
        }

        const combinedCheck = this.validateServiceOrSpecialty(
            location.selectedServices,
            this.state.deletedServices,
            location.selectedSpecialties,
            this.state.deletedSpecialties
        );

        if (combinedCheck.hasError) {
            errors.services = combinedCheck.serviceError;
            errors.specialties = combinedCheck.specialtyError;
        } else {
            // Only check individual requirements if combined check passes
            const serviceCheck = this.checkServiceRequirements(
                location.selectedServices,
                this.state.deletedServices
            );

            if (serviceCheck.hasError) {
                errors.services = serviceCheck.serviceError;
            }

            const specialtyCheck = this.checkSpecialtyRequirements(
                location.selectedSpecialties,
                this.state.deletedSpecialties
            );

            if (specialtyCheck.hasError) {
                errors.specialties = specialtyCheck.specialtyError;
            }
        }

        return {
            isValid: Object.keys(errors).length === 0,
            errors
        };
    }

    handleSaveEdit = () => {
        const location = this.state.editLocation;

        // Validate the location
        const { isValid, errors } = this.validateLocation(location);

        if (!isValid) {
            // Find the first tab with errors
            const tabWithErrors = this.findFirstTabWithErrors(errors);

            // Update state with errors and navigate to the appropriate tab
            this.setState({
                formErrors: errors,
                validationMessage: 'Please fix the validation errors before saving.',
                currentTab: tabWithErrors // Navigate to the tab with errors
            });

            // Scroll to top to show the error message
            if (this.dialogContentRef && this.dialogContentRef.current) {
                this.dialogContentRef.current.scrollTop = 0;
            }

            return;
        }

        // Clear any previous errors
        this.setState({ formErrors: {}, validationMessage: '' });

        // Convert YES/NO back to Y/N for the accepting patients flag
        let acceptingWcPatients = location.flfAcceptWcPatients || '';
        if (acceptingWcPatients === 'YES') acceptingWcPatients = 'Y';
        if (acceptingWcPatients === 'NO') acceptingWcPatients = 'N';

        // Reconstruct the address from components
        let fullAddress = location.address1 || '';
        if (location.address2) {
            fullAddress += '\n' + location.address2;
        }

        fullAddress += ', ' + (location.city || '') + ', ' + (location.state || '');

        if (location.zip) {
            fullAddress += ', ' + location.zip;
            if (location.zipExt) {
                fullAddress += ' - ' + location.zipExt;
            }
        }

        if (location.county) {
            fullAddress += ', ' + location.county;
        }
        // Build the full fax number
        let fullFaxNumber = location.faclocFaxNbr || '';
        if (location.faxExt) {
            fullFaxNumber += ' ext ' + location.faxExt;
        }
        const today = new Date();
        let acceptingWcPatientsDate = today;

        // Create the updated location object
        const updatedLocation = {
            ...location,
            address: fullAddress,
            addressString: fullAddress, // Add this line to update the addressString field
            faclocFaxNbr: fullFaxNumber,
            flfAcceptWcPatients: acceptingWcPatients,
            flfAcceptWcPatDate: acceptingWcPatientsDate,
            // Store the address components for future edits and comparisons
            addressComponents: {
                address1: location.address1 || '',
                address2: location.address2 || '',
                city: location.city || '',
                state: location.state || '',
                county: location.county || '',
                zip: location.zip || '',
                zipExt: location.zipExt || ''
            }
        };

        // Initialize arrays to prevent undefined errors
        updatedLocation.services = [];
        updatedLocation.specialties = [];
        updatedLocation.focuses = [];
        updatedLocation.languages = [];
        updatedLocation.details = [];

        // Find the original location if it exists (before using it)
        const originalLocation = this.state.originalLocations.find(
            loc => loc.flfFaclocId === location.flfFaclocId
        );

        // Process focus areas
        if (location.focusAreas && Array.isArray(location.focusAreas)) {
            // Start with an array to collect all focus areas
            let allFocusDetails = [];

            // Process existing focus areas if we have an original location
            if (originalLocation && originalLocation.focuses && Array.isArray(originalLocation.focuses)) {
                // Keep original focus areas that haven't been deleted
                const existingFocuses = originalLocation.focuses.filter(focus => {
                    const focusDesc = focus.focusShortDesc || '';
                    return !this.state.deletedFocuses.includes(focusDesc);
                });
                allFocusDetails = [...existingFocuses];
            }

            // Process newly added focus areas
            const newFocusAreas = location.focusAreas.filter(focusDesc => {
                // Check if this is a new focus area (not in the original location)
                const isExisting = originalLocation?.focuses?.some(focus =>
                    (focus.focusShortDesc || '') === focusDesc
                );
                return !isExisting && !this.state.deletedFocuses.includes(focusDesc);
            });

            // Add new focus areas to the collection
            const newFocusDetails = newFocusAreas.map(focusDesc => {
                const focusOption = this.state.focusOptions.find(option => option.value === focusDesc);
                if (focusOption) {
                    return {
                        focusId: focusOption.id,
                        focusShortDesc: focusOption.value,
                        focusAcronym: focusOption.acronym || '',
                        focusName: focusOption.value,
                        flfFaclocId: location.flfFaclocId
                    };
                }
                return null;
            }).filter(Boolean);

            allFocusDetails = [...allFocusDetails, ...newFocusDetails];

            // FIXED: Update both details and focuses with the same data
            updatedLocation.details = allFocusDetails;
            updatedLocation.focuses = allFocusDetails;
        } else {
            // FIXED: If no focus areas, preserve original focuses in both details and focuses
            if (originalLocation && originalLocation.focuses && Array.isArray(originalLocation.focuses)) {
                const existingFocuses = originalLocation.focuses.filter(focus => {
                    const focusDesc = focus.focusShortDesc || '';
                    return !this.state.deletedFocuses.includes(focusDesc);
                });
                updatedLocation.details = existingFocuses;
                updatedLocation.focuses = existingFocuses;
            }
        }

        // Process services, filtering out deleted ones
        if (location.selectedServices && Array.isArray(location.selectedServices)) {
            updatedLocation.services = location.selectedServices
                .filter(serviceValue => !this.state.deletedServices.includes(serviceValue))
                .map(serviceValue => {
                    const serviceOption = this.state.serviceOptions.find(option => option.value === serviceValue);
                    return {
                        serviceId: serviceOption ? serviceOption.id : null,
                        serviceDesc: serviceValue,
                        fsrShortDesc: serviceValue,
                        flfFaclocId: location.flfFaclocId,
                    };
                });
        }

        // Process specialties, filtering out deleted ones
        if (location.selectedSpecialties && Array.isArray(location.selectedSpecialties)) {
            updatedLocation.specialties = location.selectedSpecialties
                .filter(specialtyValue => !this.state.deletedSpecialties.includes(specialtyValue))
                .map(specialtyValue => {
                    const specialtyOption = this.state.specialtyOptions.find(option => option.value === specialtyValue);
                    return {
                        specialtyId: specialtyOption ? specialtyOption.id : null,
                        specialtyDesc: specialtyValue,
                        flfFaclocId: location.flfFaclocId,
                        specDesc: specialtyValue
                    };
                });
        }

        // Process languages, filtering out deleted ones
        if (location.selectedLanguages && Array.isArray(location.selectedLanguages)) {
            updatedLocation.languages = location.selectedLanguages
                .filter(languageValue => !this.state.deletedLanguages.includes(languageValue))
                .map(languageValue => {
                    const languageOption = this.state.languageOptions.find(option => option.value === languageValue);
                    return {
                        languageId: languageOption ? languageOption.id : null,
                        languageDesc: languageValue,
                        flfFaclocId: location.flfFaclocId,
                        lngLanguageName: languageValue
                    };
                });
        }

        // Remove the temporary fields used only for editing
        delete updatedLocation.address1;
        delete updatedLocation.address2;
        delete updatedLocation.city;
        delete updatedLocation.state;
        delete updatedLocation.county;
        delete updatedLocation.zip;
        delete updatedLocation.zipExt;
        delete updatedLocation.faxExt;
        delete updatedLocation.focusAreas;
        delete updatedLocation.selectedServices;
        delete updatedLocation.selectedSpecialties;
        delete updatedLocation.selectedLanguages;

        console.log('Saving edited location with address components:', updatedLocation);

        // Track the change based on whether it's new or edited
        if (location.isNew) {
            console.log('Tracking as new location (add)');
            // For new locations, track as 'add'
            this.trackChange('add', {}, updatedLocation, updatedLocation.flfFaclocId);
        } else {
            console.log('Tracking as edited location');
            console.log('Original location:', originalLocation);

            // FIXED: Ensure original location has details populated from focuses
            const originalWithDetails = {
                ...originalLocation,
                // If original doesn't have details, populate it from focuses
                details: originalLocation?.details && originalLocation.details.length > 0
                    ? originalLocation.details
                    : (originalLocation?.focuses || [])
            };

            console.log('Original with details:', originalWithDetails);

            // For existing locations, track as 'edit'
            this.trackChange('edit', originalWithDetails, updatedLocation, updatedLocation.flfFaclocId);
        }

        // Close the edit dialog
        this.setState({
            editLocation: null,
            showEditDlg: false,
            currentTab: 0,
            serviceSearchTerm: '',
            specialtySearchTerm: '',
            focusSearchTerm: '',
            languageSearchTerm: '',
            // Reset deleted items arrays
            deletedServices: [],
            deletedSpecialties: [],
            deletedFocuses: [],
            deletedLanguages: []
        });
    }
    getCurrentLocations = () => {
        // Start with original locations
        let currentLocations = JSON.parse(JSON.stringify(this.state.originalLocations || []));

        // Apply all tracked changes
        this.state.changeTracking.forEach(change => {
            if (change.action === 'edit') {
                const index = currentLocations.findIndex(loc => loc.flfFaclocId === change.id);
                if (index !== -1) {
                    // Ensure consistent property names
                    if (change.newObj.Languages && !change.newObj.languages) {
                        change.newObj.languages = change.newObj.Languages;
                        delete change.newObj.Languages;
                    }

                    // FIXED: Always ensure addressString is set when address exists
                    if (change.newObj.address && !change.newObj.addressString) {
                        change.newObj.addressString = change.newObj.address;
                    }

                    currentLocations[index] = change.newObj;
                }
            } else if (change.action === 'add') {
                // Add new locations with consistent property names
                const newLoc = { ...change.newObj };
                if (newLoc.Languages && !newLoc.languages) {
                    newLoc.languages = newLoc.Languages;
                    delete newLoc.Languages;
                }

                // FIXED: Ensure addressString is set for new locations too
                if (newLoc.address && !newLoc.addressString) {
                    newLoc.addressString = newLoc.address;
                }

                currentLocations.push(newLoc);
            }
        });

        return currentLocations;
    }


    handleDeleteLocation = () => {
        const locationToDelete = this.state.locationToDelete;
        if (!locationToDelete) return;

        const locationId = locationToDelete.flfFaclocId;
        const isNewLocation = locationToDelete.isNew;

        // For existing locations, ensure we have address components
        if (!isNewLocation && !locationToDelete.addressComponents && locationToDelete.ofcDirectoryAddId) {
            // Fetch address data first
            ProviderService.getAddressById(locationToDelete.ofcDirectoryAddId)
                .then((response) => {
                    if (isNotEmpty(response.data)) {
                        const data = response.data;
                        const addressComponents = {
                            address1: data.addStreet1 || '',
                            address2: data.addStreet2 || '',
                            city: data.addCity || '',
                            state: data.addState || '',
                            county: data.addCounty || '',
                            zip: data.addZipCode || '',
                            zipExt: data.addZipPlusFour || ''
                        };

                        // Reconstruct full address string if not present
                        let fullAddress = '';
                        if (!locationToDelete.address && !locationToDelete.addressString) {
                            fullAddress = addressComponents.address1;
                            if (addressComponents.address2) fullAddress += '\n' + addressComponents.address2;
                            fullAddress += ', ' + addressComponents.city + ' ' + addressComponents.state;
                            if (addressComponents.county) fullAddress += ', ' + addressComponents.county;
                            fullAddress += ', ' + addressComponents.zip;
                            if (addressComponents.zipExt) fullAddress += '-' + addressComponents.zipExt;
                        } else {
                            fullAddress = locationToDelete.address || locationToDelete.addressString || '';
                        }

                        // Create a complete location object with address components
                        const completeLocationToDelete = {
                            ...locationToDelete,
                            addressComponents: addressComponents,
                            address: fullAddress,
                            addressString: fullAddress
                        };

                        // Now proceed with deletion using the complete object
                        this.trackChange('delete', completeLocationToDelete, null, locationId);
                    } else {
                        // If no data, proceed with what we have
                        this.trackChange('delete', locationToDelete, null, locationId);
                    }
                })
                .catch(() => {
                    // If fetch fails, proceed with what we have
                    this.trackChange('delete', locationToDelete, null, locationId);
                })
                .finally(() => {
                    this.setState({
                        showDeleteConfirmDialog: false,
                        locationToDelete: null
                    });
                });
        } else {
            // For new locations or those with address components, proceed as before
            if (isNewLocation) {
                // Handle new location deletion
                this.setState(prevState => {
                    const updatedChangeTracking = prevState.changeTracking.filter(
                        change => change.id !== locationId
                    );
                    return {
                        changeTracking: updatedChangeTracking,
                        showDeleteConfirmDialog: false,
                        locationToDelete: null,
                        hasLocalChanges: updatedChangeTracking.length > 0
                    };
                }, () => {
                    this.updateDisplayedLocations();
                });
            } else {
                // Handle existing location deletion
                const originalLocation = this.state.originalLocations.find(
                    loc => loc.flfFaclocId === locationId
                );

                if (originalLocation) {
                    // Ensure address string is available
                    if (!locationToDelete.address && !locationToDelete.addressString && locationToDelete.addressComponents) {
                        const components = locationToDelete.addressComponents;
                        let fullAddress = components.address1;
                        if (components.address2) fullAddress += '\n' + components.address2;
                        fullAddress += ', ' + components.city + ' ' + components.state;
                        if (components.county) fullAddress += ', ' + components.county;
                        fullAddress += ', ' + components.zip;
                        if (components.zipExt) fullAddress += '-' + components.zipExt;

                        locationToDelete.address = fullAddress;
                        locationToDelete.addressString = fullAddress;
                    }

                    this.trackChange('delete', locationToDelete, null, locationId);
                }

                this.setState({
                    showDeleteConfirmDialog: false,
                    locationToDelete: null
                });
            }
        }
    }

    generateChangesSummary = () => {
        const { changeTracking } = this.state;

        // Track changes
        const summary = {
            newLocations: [],
            modifiedLocations: [],
            deletedLocations: []
        };

        // Helper function to format address consistently
        const formatAddressConsistently = (location) => {
            if (!location) return location;

            // If we have address components, reconstruct the address in the desired format
            if (location.addressComponents) {
                const components = location.addressComponents;
                let formattedAddress = components.address1 || '';
                if (components.address2) formattedAddress += '\n' + components.address2;
                formattedAddress += ', ' + (components.city || '') + ', ' + (components.state || '');
                if (components.zip) {
                    formattedAddress += ', ' + components.zip;
                    if (components.zipExt) formattedAddress += ' - ' + components.zipExt;
                }
                if (components.county) formattedAddress += ', ' + components.county;

                // FIXED: Always set both fields
                location.address = formattedAddress;
                location.addressString = formattedAddress;
            } else if (!location.addressString && location.address) {
                // FIXED: If no components but address exists, ensure addressString is set
                location.addressString = location.address;
            }

            return location;
        };

        // Process all tracked changes
        changeTracking.forEach(change => {
            if (change.action === 'add') {
                // Format address for new locations
                const newObj = formatAddressConsistently({ ...change.newObj });
                summary.newLocations.push(newObj);
            }
            else if (change.action === 'edit') {
                // FIXED: Deep copy to avoid mutation of original state
                const originalObj = JSON.parse(JSON.stringify(change.originalObj));
                const modifiedObj = JSON.parse(JSON.stringify(change.newObj));

                // Format address for both original and modified objects
                formatAddressConsistently(originalObj);
                formatAddressConsistently(modifiedObj);

                // FIXED: Ensure details/focuses are properly initialized in original object
                // This prevents focus areas from other locations bleeding into this one
                if (!originalObj.details) {
                    originalObj.details = [];
                }
                if (!originalObj.focuses) {
                    originalObj.focuses = [];
                }

                // FIXED: Also ensure services, specialties, languages are initialized
                if (!originalObj.services) {
                    originalObj.services = [];
                }
                if (!originalObj.specialties) {
                    originalObj.specialties = [];
                }
                if (!originalObj.languages) {
                    originalObj.languages = [];
                }

                // FIXED: Ensure modified object also has proper arrays
                if (!modifiedObj.details) {
                    modifiedObj.details = [];
                }
                if (!modifiedObj.focuses) {
                    modifiedObj.focuses = [];
                }
                if (!modifiedObj.services) {
                    modifiedObj.services = [];
                }
                if (!modifiedObj.specialties) {
                    modifiedObj.specialties = [];
                }
                if (!modifiedObj.languages) {
                    modifiedObj.languages = [];
                }

                summary.modifiedLocations.push({
                    original: originalObj,
                    modified: modifiedObj
                });
            }
            else if (change.action === 'delete') {
                // Format address for deleted locations
                const originalObj = formatAddressConsistently({ ...change.originalObj });
                summary.deletedLocations.push(originalObj);
            }
        });

        console.log('Generated changes summary:', summary);
        return summary;
    }
    handleShowChanges = () => {
        console.log('Showing changes summary');

        // If there are no changes, do nothing
        if (!this.state.hasLocalChanges) {
            console.log('No local changes to review');
            return;
        }

        // Generate a summary of changes for the dialog
        const changesSummary = this.generateChangesSummary();

        console.log('Changes summary:', changesSummary);

        // Show the changes summary dialog
        this.setState({
            changesSummary,
            showChangesSummaryDialog: true
        });


    };
    handleAddService = (serviceValue) => {
        // Find the service option object to remove from available options
        const serviceOption = this.state.serviceOptions.find(option => option.value === serviceValue);

        this.setState(prevState => {
            // Create updated state
            const updatedState = {
                editLocation: {
                    ...prevState.editLocation,
                    selectedServices: [
                        ...(prevState.editLocation.selectedServices || []),
                        serviceValue
                    ]
                },
                // Remove the selected service from available options
                serviceOptions: prevState.serviceOptions.filter(option => option.value !== serviceValue)
            };

            // Clear service-related error messages
            const updatedFormErrors = { ...prevState.formErrors };
            delete updatedFormErrors.services;

            // Also clear the validation message if it was about services
            let updatedValidationMessage = prevState.validationMessage;
            if (updatedValidationMessage &&
                (updatedValidationMessage.includes("service") ||
                    updatedValidationMessage.includes("Service"))) {
                updatedValidationMessage = '';
            }

            // Add these cleared errors to the state update
            updatedState.formErrors = updatedFormErrors;
            updatedState.validationMessage = updatedValidationMessage;

            return updatedState;
        });
    };

    // Service handlers
    handleRemoveService = (serviceValue) => {

        if (this.props.type === "H" || this.props.type === "A") {
            const currentServices = this.state.editLocation.selectedServices || [];
            const deletedServices = this.state.deletedServices || [];

            // Calculate active services after this deletion
            const activeServices = currentServices.filter(
                service => !deletedServices.includes(service)
            );

            // If this would remove the last service, prevent it
            if (activeServices.length === 1 && activeServices[0] === serviceValue) {
                // Show error message in a more visible way
                this.setState({
                    validationMessage: "One primary service is required."
                });

                // Scroll to top to make sure the error message is visible
                if (this.dialogContentRef && this.dialogContentRef.current) {
                    this.dialogContentRef.current.scrollTop = 0;
                }

                return; // Exit without removing
            }
        }
        // Check if this was an original service (not newly added)
        const isOriginalService = this.props.locations.some(loc =>
            loc.flfFaclocId === this.state.editLocation.flfFaclocId &&
            loc.services &&
            loc.services.some(service =>
                (service.serviceDesc === serviceValue || service.fsrShortDesc === serviceValue)
            )
        );

        if (isOriginalService) {
            // Mark as deleted but keep in the list with strike-through
            this.setState(prevState => ({
                deletedServices: [...prevState.deletedServices, serviceValue]
            }));
        } else {
            // For newly added services, remove completely
            this.setState(prevState => ({
                editLocation: {
                    ...prevState.editLocation,
                    selectedServices: prevState.editLocation.selectedServices.filter(
                        service => service !== serviceValue
                    )
                }
            }));

            // Find the service in our options or create a new option object
            const serviceOption = this.state.serviceOptions.find(s => s.value === serviceValue) || {
                id: `temp_${Date.now()}`,
                value: serviceValue,
                label: serviceValue
            };

            // Add back to available options and sort alphabetically
            this.setState(prevState => {
                const updatedOptions = [...prevState.serviceOptions, serviceOption]
                    .sort((a, b) => a.label.localeCompare(b.label));

                return { serviceOptions: updatedOptions };
            });
        }
    };

    handleRemoveSpecialty = (specialtyValue) => {
        if (this.props.type === "A" && this.hasPhysicianGroupParticipation()) {
            const currentSpecialties = this.state.editLocation.selectedSpecialties || [];
            const deletedSpecialties = this.state.deletedSpecialties || [];

            // Calculate active specialties after this deletion
            const activeSpecialties = currentSpecialties.filter(
                specialty => !deletedSpecialties.includes(specialty)
            );

            // If this would remove the last specialty, prevent it
            if (activeSpecialties.length === 1 && activeSpecialties[0] === specialtyValue) {
                // Show error message
                this.setState({
                    validationMessage: "Specialty is required."
                });

                // Scroll to top to make sure the error message is visible
                if (this.dialogContentRef && this.dialogContentRef.current) {
                    this.dialogContentRef.current.scrollTop = 0;
                }

                return; // Exit without removing
            }
        }
        // Check if this was an original specialty (not newly added)
        const isOriginalSpecialty = this.props.locations.some(loc =>
            loc.flfFaclocId === this.state.editLocation.flfFaclocId &&
            loc.specialties &&
            loc.specialties.some(specialty =>
                (specialty.specialtyDesc === specialtyValue || specialty.specDesc === specialtyValue)
            )
        );

        if (isOriginalSpecialty) {
            // Mark as deleted but keep in the list with strike-through
            this.setState(prevState => ({
                deletedSpecialties: [...prevState.deletedSpecialties, specialtyValue]
            }));
        } else {
            // For newly added specialties, remove completely
            this.setState(prevState => ({
                editLocation: {
                    ...prevState.editLocation,
                    selectedSpecialties: prevState.editLocation.selectedSpecialties.filter(
                        specialty => specialty !== specialtyValue
                    )
                }
            }));

            // Add back to available options if it was from there
            const specialtyToAdd = this.state.specialtyOptions.find(s => s.value === specialtyValue);
            if (specialtyToAdd) {
                this.setState(prevState => ({
                    specialtyOptions: [...prevState.specialtyOptions, specialtyToAdd]
                }));
            }
        }
    };

    handleUndoSpecialtyDelete = (specialtyValue) => {
        this.setState(prevState => {
            // Create the basic state update
            const updatedState = {
                deletedSpecialties: prevState.deletedSpecialties.filter(specialty => specialty !== specialtyValue)
            };

            // Clear specialty-related error messages
            const updatedFormErrors = { ...prevState.formErrors };
            delete updatedFormErrors.specialties;

            // Also clear the validation message if it was about specialties
            let updatedValidationMessage = prevState.validationMessage;
            if (updatedValidationMessage &&
                (updatedValidationMessage.includes("specialty") ||
                    updatedValidationMessage.includes("Specialty"))) {
                updatedValidationMessage = '';
            }

            // Add these cleared errors to the state update
            updatedState.formErrors = updatedFormErrors;
            updatedState.validationMessage = updatedValidationMessage;

            return updatedState;
        });
    };

    handleUndoFocusDelete = (focusValue) => {
        this.setState(prevState => ({
            deletedFocuses: prevState.deletedFocuses.filter(focus => focus !== focusValue)
        }));

        // Ensure available options list is sorted
        this.setState(prevState => {
            const sortedOptions = [...prevState.focusOptions]
                .sort((a, b) => a.label.localeCompare(b.label));

            return { focusOptions: sortedOptions };
        });
    };
    handleUndoServiceDelete = (serviceValue) => {
        this.setState(prevState => {
            // Create the basic state update
            const updatedState = {
                deletedServices: prevState.deletedServices.filter(service => service !== serviceValue)
            };

            // Clear service-related error messages
            const updatedFormErrors = { ...prevState.formErrors };
            delete updatedFormErrors.services;

            // Also clear the validation message if it was about services
            let updatedValidationMessage = prevState.validationMessage;
            if (updatedValidationMessage &&
                (updatedValidationMessage.includes("service") ||
                    updatedValidationMessage.includes("Service"))) {
                updatedValidationMessage = '';
            }

            // Add these cleared errors to the state update
            updatedState.formErrors = updatedFormErrors;
            updatedState.validationMessage = updatedValidationMessage;

            return updatedState;
        });
    };


    handleAddSpecialty = (specialtyValue) => {
        // Find the specialty option object to remove from available options
        const specialtyOption = this.state.specialtyOptions.find(option => option.value === specialtyValue);

        this.setState(prevState => {
            // Create updated state
            const updatedState = {
                editLocation: {
                    ...prevState.editLocation,
                    selectedSpecialties: [
                        ...(prevState.editLocation.selectedSpecialties || []),
                        specialtyValue
                    ]
                },
                // Remove the selected specialty from available options
                specialtyOptions: prevState.specialtyOptions.filter(option => option.value !== specialtyValue)
            };

            // Clear specialty-related error messages
            const updatedFormErrors = { ...prevState.formErrors };
            delete updatedFormErrors.specialties;

            // Also clear the validation message if it was about specialties
            let updatedValidationMessage = prevState.validationMessage;
            if (updatedValidationMessage &&
                (updatedValidationMessage.includes("specialty") ||
                    updatedValidationMessage.includes("Specialty"))) {
                updatedValidationMessage = '';
            }

            // Add these cleared errors to the state update
            updatedState.formErrors = updatedFormErrors;
            updatedState.validationMessage = updatedValidationMessage;

            return updatedState;
        });
    };

    handleAddFocus = (focusValue) => {
        // For focus areas, we don't remove from available options when selected
        // We just add to selected list
        this.setState(prevState => ({
            editLocation: {
                ...prevState.editLocation,
                focusAreas: [
                    ...(prevState.editLocation.focusAreas || []),
                    focusValue
                ]
            }
        }));
    };

    handleRemoveFocus = (focusValue) => {
        // Check if this was an original focus area (not newly added)
        const isOriginalFocus = this.props.locations.some(loc =>
            loc.flfFaclocId === this.state.editLocation.flfFaclocId &&
            loc.focuses &&
            loc.focuses.some(focus =>
                (focus.focusShortDesc === focusValue || focus.value === focusValue)
            )
        );

        if (isOriginalFocus) {
            // Mark as deleted but keep in the list with strike-through
            this.setState(prevState => ({
                deletedFocuses: [...prevState.deletedFocuses, focusValue]
            }));
        } else {
            // For newly added focus areas, simply remove from selected list
            this.setState(prevState => ({
                editLocation: {
                    ...prevState.editLocation,
                    focusAreas: prevState.editLocation.focusAreas.filter(
                        focus => focus !== focusValue
                    )
                }
            }));

            // Even though we don't need to add back to available options,
            // we should still ensure the available options list is sorted
            this.setState(prevState => {
                const sortedOptions = [...prevState.focusOptions]
                    .sort((a, b) => a.label.localeCompare(b.label));

                return { focusOptions: sortedOptions };
            });
        }
    };

    handleAddLanguage = (languageValue) => {
        // For languages, we don't remove from available options when selected
        // We just add to selected list
        this.setState(prevState => ({
            editLocation: {
                ...prevState.editLocation,
                selectedLanguages: [
                    ...(prevState.editLocation.selectedLanguages || []),
                    languageValue
                ]
            }
        }));
    };

    handleRemoveLanguage = (languageValue) => {
        // Check if this was an original language (not newly added)
        const isOriginalLanguage = this.props.locations.some(loc =>
            loc.flfFaclocId === this.state.editLocation.flfFaclocId &&
            loc.languages &&
            loc.languages.some(language =>
                (language.languageDesc === languageValue || language.lngLanguageName === languageValue || language.value === languageValue)
            )
        );

        if (isOriginalLanguage) {
            // Mark as deleted but keep in the list with strike-through
            this.setState(prevState => ({
                deletedLanguages: [...prevState.deletedLanguages, languageValue]
            }));
        } else {
            // For newly added languages, simply remove from selected list
            this.setState(prevState => ({
                editLocation: {
                    ...prevState.editLocation,
                    selectedLanguages: prevState.editLocation.selectedLanguages.filter(
                        language => language !== languageValue
                    )
                }
            }));

            // Ensure available options list is sorted
            this.setState(prevState => {
                const sortedOptions = [...prevState.languageOptions]
                    .sort((a, b) => a.label.localeCompare(b.label));

                return { languageOptions: sortedOptions };
            });
        }
    };

    handleUndoLanguageDelete = (languageValue) => {
        this.setState(prevState => ({
            deletedLanguages: prevState.deletedLanguages.filter(language => language !== languageValue)
        }));

        // Ensure available options list is sorted
        this.setState(prevState => {
            const sortedOptions = [...prevState.languageOptions]
                .sort((a, b) => a.label.localeCompare(b.label));

            return { languageOptions: sortedOptions };
        });
    };



    // Add method to close the changes summary dialog
    handleCloseChangesSummary = () => {
        this.setState({ showChangesSummaryDialog: false });
    }

    handleDiscardChanges = () => {
        //console.log('Discarding all changes');
        //console.log('Current change tracking to discard:', this.state.changeTracking);
        //console.log('Reverting to pristine locations:', this.state.pristineLocations);

        // Reset to pristine data from when the component first loaded
        const pristineLocations = JSON.parse(JSON.stringify(this.state.pristineLocations));

        // Update both working and original locations to pristine state
        this.setState({
            originalLocations: pristineLocations,
            workingLocations: pristineLocations,
            deletedLocations: [],
            changeTracking: [],
            hasLocalChanges: false
        }, () => {
            //console.log('Change tracking after discard (should be empty):', this.state.changeTracking);

            // Update the parent component with pristine data
            if (this.props.setFilter) {
                this.props.setFilter(pristineLocations);
            }

            // Notify parent component about discarded changes
            if (this.props.onSectionDiscardChanges) {
                this.props.onSectionDiscardChanges({
                    pristineObject: pristineLocations,
                    modifiedObject: null
                });
            }

            // Notify parent that this section no longer has unsaved changes
            if (this.props.onSectionHasChanges) {
                this.props.onSectionHasChanges(false);
            }
        });
    }

    render() {
        const { classes, type } = this.props;
        const isHospital = type === "H";
        const {
            editLocation,
            showEditDlg,
            locationToDelete,
            showDeleteConfirmDialog
        } = this.state;


        const displayLocations = this.props.filtered || [];


        return (
            <div style={{ width: '100%', maxWidth: '100%' }}>

                <Dialog
                    open={this.state.showDlg}
                    onClose={this.closeMsgDlg}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    className={classes.dialog}
                >
                    <DialogTitle variant="h2">Location: {this.state.officeName}</DialogTitle>

                    <Grid
                        container
                        justifyContent="space-between"
                        style={{ paddingLeft: "1em" }}
                    >
                        {(this.state.services.length > 0) ?
                            <FacilityLocationServicesDtlsTbl
                                dtlss={this.state.filteredServices}
                                setFilter={this.setFilterServices}
                                filtered={this.state.services}
                            /> : null}

                        {/* Only show specialties for Ancillary facilities */}
                        {(!isHospital && this.state.specialties.length > 0) ?
                            <FacilityLocationSpclDtlsTbl
                                dtlss={this.state.filteredSpecialties}
                                setFilter={this.setFilterSpecialties}
                                filtered={this.state.specialties}
                            /> : null}

                        {/* Only show focuses for Ancillary facilities */}
                        {(!isHospital && this.state.focuses.length > 0) ?
                            <FacilityLocationFocusDtlsTbl
                                dtlss={this.state.filteredFocuses}
                                setFilter={this.setFilterFocuses}
                                filtered={this.state.focuses}
                            /> : null}

                        {(this.state.languages.length > 0) ? // Corrected spelling
                            <FacilityLocationLangDtlsTbl
                                dtlss={this.state.filteredLanguages} // Corrected spelling
                                setFilter={this.setFilterLanguages} // Corrected spelling
                                filtered={this.state.languages} // Corrected spelling
                            /> : null}
                    </Grid>

                    <div style={{ textAlign: 'center' }}>
                        <Button variant="outlined" onClick={this.closeMsgDlg} aria-label='PROVIDER DEMOGRAPHICS: Facility Locations: Additional Information VIEW DETAILS CLOSE Button '>
                            CLOSE
                        </Button>
                    </div>
                </Dialog>
                {/* Last Location Warning Dialog */}
                <Dialog
                    open={this.state.showLastLocationWarning || false}
                    onClose={() => this.setState({ showLastLocationWarning: false })}
                    aria-labelledby="last-location-warning-title"
                >
                    <DialogTitle id="single-location-warning-title">
                        <Box display="flex" alignItems="center">
                            <WarningIcon
                                style={{
                                    color: '#f57c00', // Orange warning color
                                    marginRight: '8px',
                                    fontSize: '28px'
                                }}
                            />
                            Cannot Delete Only Location
                        </Box>

                    </DialogTitle>
                    <DialogContent>
                        <Typography>
                            Requests to terminate your only remaining practice location will not be processed without the addition of a replacement location.
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => this.setState({ showLastLocationWarning: false })}
                            color="primary"
                            variant="contained"
                        >
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={showEditDlg}
                    onClose={this.closeEditDlg}
                    aria-labelledby="edit-dialog-title"
                    aria-describedby="edit-dialog-description"
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle id="edit-dialog-title">
                        {editLocation?.isNew ? "Add New Location" : "Edit Location"}
                    </DialogTitle>
                    <DialogContent ref={this.dialogContentRef}>
                        {this.state.validationMessage && (
                            <div style={{
                                backgroundColor: '#f8d7da',
                                color: '#721c24',
                                padding: '12px',
                                borderRadius: '4px',
                                marginBottom: '16px',
                                border: '1px solid #f5c6cb'
                            }}>
                                <Typography variant="body2" style={{ fontWeight: 500 }}>
                                    {this.state.validationMessage}
                                </Typography>
                            </div>
                        )}

                        {editLocation && (
                            <>
                                <Tabs
                                    value={this.state.currentTab}
                                    onChange={this.handleTabChange}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    variant="fullWidth"
                                    aria-label="location edit tabs"
                                >
                                    <Tab
                                        label={
                                            <span>
                                                General
                                                {this.hasTabErrors("General") && (
                                                    <span style={{ color: 'red', marginLeft: '5px' }}>!</span>
                                                )}
                                            </span>
                                        }
                                        id="tab-0"
                                        aria-controls="tabpanel-0"
                                    />

                                    {this.state.showServicesTab &&
                                        <Tab
                                            label={
                                                <span>
                                                    Services
                                                    <span style={{ color: '#b0170c', marginLeft: '5px' }}>*</span>
                                                    {this.hasTabErrors("Services") && (
                                                        <span style={{ color: 'red', marginLeft: '2px' }}>!</span>
                                                    )}
                                                </span>
                                            }
                                            id={`tab-${this.getTabIndex("Services")}`}
                                            aria-controls={`tabpanel-${this.getTabIndex("Services")}`}
                                        />
                                    }

                                    {/* Show Specialties tab for Physician Group providers */}
                                    {this.state.showSpecialtiesTab &&
                                        <Tab
                                            label={
                                                <span>
                                                    Specialties
                                                    <span style={{ color: '#b0170c', marginLeft: '5px' }}>*</span>
                                                    {this.hasTabErrors("Specialties") && (
                                                        <span style={{ color: 'red', marginLeft: '5px' }}>!</span>
                                                    )}
                                                </span>
                                            }
                                            id={`tab-${this.getTabIndex("Specialties")}`}
                                            aria-controls={`tabpanel-${this.getTabIndex("Specialties")}`}
                                        />
                                    }

                                    {/* Dynamic indices for Focus Areas tab */}
                                    {this.state.showFocusAreasTab &&
                                        <Tab
                                            label={
                                                <span>
                                                    Focus Areas
                                                    {this.hasTabErrors("Focus Areas") && (
                                                        <span style={{ color: 'red', marginLeft: '5px' }}>!</span>
                                                    )}
                                                </span>
                                            }
                                            id={`tab-${this.getTabIndex("Focus Areas")}`}
                                            aria-controls={`tabpanel-${this.getTabIndex("Focus Areas")}`}
                                        />
                                    }

                                    {/* Dynamic indices for Languages tab */}
                                    <Tab
                                        label={
                                            <span>
                                                Languages
                                                {this.hasTabErrors("Languages") && (
                                                    <span style={{ color: 'red', marginLeft: '5px' }}>!</span>
                                                )}
                                            </span>
                                        }
                                        id={`tab-${this.getTabIndex("Languages")}`}
                                        aria-controls={`tabpanel-${this.getTabIndex("Languages")}`}
                                    />
                                </Tabs>
                                {/* General Tab */}
                                <TabPanel value={this.state.currentTab} index={0}>
                                    {this.state.currentTab === 0 && this.hasTabErrors("General") && (
                                        <Box
                                            sx={{
                                                backgroundColor: '#fff3e0',
                                                padding: '8px 16px',
                                                borderRadius: '4px',
                                                marginBottom: '16px',
                                                border: '1px solid #ffcc80'
                                            }}
                                        >
                                            <Typography variant="body2" color="error">
                                                Please correct the highlighted fields below.
                                            </Typography>
                                        </Box>
                                    )}
                                    <Grid container spacing={2}>
                                        {/* LocationTIN field - from props */}
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                name="ptcTaxId"
                                                label="Location TIN"
                                                value={this.props.ptcTaxId || ''}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                disabled={true} // Read-only since it comes from props
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        </Grid>

                                        {/* Office Name field */}
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                name="faclocDirectoryLocName"
                                                label="Location Name"
                                                value={editLocation.faclocDirectoryLocName || ''}
                                                onChange={this.handleInputChange}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                error={!!this.state.formErrors?.faclocDirectoryLocName}
                                                helperText={this.state.formErrors?.faclocDirectoryLocName || "Required"}
                                                required
                                                disabled={!editLocation.isNew}
                                            />
                                        </Grid>

                                        {/* LocationNPI field - from location object */}
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                name="faclocNpi"
                                                label="Location NPI"
                                                value={editLocation.faclocNpi || ''}
                                                onChange={this.handleInputChange}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                error={!!this.state.formErrors?.faclocNpi}
                                                helperText={this.state.formErrors?.faclocNpi || "Optional (10 digits)"}
                                                inputProps={{ maxLength: 10 }}
                                            />
                                        </Grid>

                                        {/* Address Information Section */}
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2" style={{ marginTop: '10px', marginBottom: '-5px' }}>
                                                Address Information
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <TextField
                                                name="address1"
                                                label="Address Line 1"
                                                value={editLocation.address1 || ''}
                                                onChange={this.handleInputChange}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                error={!!this.state.formErrors?.address1}
                                                helperText={this.state.formErrors?.address1 || "Required"}
                                                required
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <TextField
                                                name="address2"
                                                label="Address Line 2"
                                                value={editLocation.address2 || ''}
                                                onChange={this.handleInputChange}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                            />
                                        </Grid>

                                        {/* City, State, County fields */}
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                name="city"
                                                label="City"
                                                value={editLocation.city || ''}
                                                onChange={this.handleInputChange}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                error={!!this.state.formErrors?.city}
                                                helperText={this.state.formErrors?.city || "Required"}
                                                required
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                name="state"
                                                label="State"
                                                value={editLocation.state || ''}
                                                onChange={this.handleStateInputChange}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                select
                                                SelectProps={{
                                                    native: true,
                                                }}
                                                error={!!this.state.formErrors?.state}
                                                helperText={this.state.formErrors?.state || "Required"}
                                                required
                                                disabled={this.state.loadingStates}
                                            >
                                                <option value="">
                                                    {this.state.loadingStates
                                                        ? "Loading states..."
                                                        : "Select..."}
                                                </option>
                                                {this.state.stateOptions.map((state) => (
                                                    <option key={state.value} value={state.value}>
                                                        {state.label}
                                                    </option>
                                                ))}
                                            </TextField>
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                name="county"
                                                label="County"
                                                value={editLocation.county || ''}
                                                onChange={this.handleCountyChange}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                select
                                                SelectProps={{
                                                    native: true,
                                                }}
                                                error={!!this.state.formErrors?.county}
                                                helperText={this.state.formErrors?.county || "Optional"}
                                                disabled={this.state.loadingCounties || this.state.countyOptions.length === 0}
                                            >
                                                <option value="">
                                                    {this.state.loadingCounties
                                                        ? "Loading counties..."
                                                        : this.state.countyOptions.length === 0
                                                            ? "Select state first"
                                                            : "Select county..."}
                                                </option>
                                                {this.state.countyOptions.map((county) => (
                                                    <option key={county.value} value={county.value}>
                                                        {county.label}
                                                    </option>
                                                ))}
                                            </TextField>
                                        </Grid>

                                        {/* ZIP Code and Extension fields */}
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                name="zip"
                                                label="ZIP Code"
                                                value={editLocation.zip || ''}
                                                onChange={this.handleInputChange}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                error={!!this.state.formErrors?.zip}
                                                helperText={this.state.formErrors?.zip || "5 digits"}
                                                required
                                                inputProps={{ maxLength: 5 }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={2}>
                                            <TextField
                                                name="zipExt"
                                                label="ZIP Extension"
                                                value={editLocation.zipExt || ''}
                                                onChange={this.handleInputChange}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                error={!!this.state.formErrors?.zipExt}
                                                helperText={this.state.formErrors?.zipExt || "4 digits (optional)"}
                                                inputProps={{ maxLength: 4 }}
                                            />
                                        </Grid>

                                        {/* Contact information */}
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2" style={{ marginTop: '10px', marginBottom: '-5px' }}>
                                                Location Information
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                name="faclocDirectoryPhoneNbr"
                                                label="Phone Number"
                                                value={editLocation.faclocDirectoryPhoneNbr || ''}
                                                onChange={this.handlePhoneInputChange}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                error={!!this.state.formErrors?.faclocDirectoryPhoneNbr}
                                                helperText={this.state.formErrors?.faclocDirectoryPhoneNbr || "Required (10 digits)"}
                                                required
                                                placeholder="(555) 555-5555"
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                name="faclocFaxNbr"
                                                label="Fax Number"
                                                value={editLocation.faclocFaxNbr || ''}
                                                onChange={this.handlePhoneInputChange}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                error={!!this.state.formErrors?.faclocFaxNbr}
                                                helperText={this.state.formErrors?.faclocFaxNbr || "Optional (10 digits)"}
                                                placeholder="(555) 555-5555"
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                name="faclocEmailAddress"
                                                label="Email Address"
                                                value={editLocation.faclocEmailAddress || ''}
                                                onChange={this.handleInputChange}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                error={!!this.state.formErrors?.faclocEmailAddress}
                                                helperText={this.state.formErrors?.faclocEmailAddress || "Optional"}
                                                type="email"
                                            />
                                        </Grid>

                                        {/* For Existing Locations - Show selection with previous value message */}
                                        {!editLocation.isNew && (
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    name="flfAcceptWcPatients"
                                                    label="Accepting New WC?"
                                                    value={editLocation.flfAcceptWcPatients || ''}
                                                    onChange={this.handleInputChange}
                                                    fullWidth
                                                    margin="normal"
                                                    variant="outlined"
                                                    select
                                                    SelectProps={{
                                                        native: true,
                                                    }}
                                                    error={!!this.state.formErrors?.flfAcceptWcPatients}
                                                    helperText={
                                                        this.state.formErrors?.flfAcceptWcPatients ||
                                                        editLocation.wcPatientsHelperText ||
                                                        `Previous value is ${editLocation.currentAcceptingWcValue || '(Not Set)'}, Please select a value.`
                                                    }
                                                    required
                                                >
                                                    <option value="">Select...</option>
                                                    <option value="YES">Yes</option>
                                                    <option value="NO">No</option>
                                                </TextField>
                                            </Grid>
                                        )}

                                        {/* For New Locations - Just show the selection field */}
                                        {editLocation.isNew && (
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    name="flfAcceptWcPatients"
                                                    label="Accepting New WC?"
                                                    value={editLocation.flfAcceptWcPatients || ''}
                                                    onChange={this.handleInputChange}
                                                    fullWidth
                                                    margin="normal"
                                                    variant="outlined"
                                                    select
                                                    SelectProps={{
                                                        native: true,
                                                    }}
                                                    error={!!this.state.formErrors?.flfAcceptWcPatients}
                                                    helperText={this.state.formErrors?.flfAcceptWcPatients || "Required"}
                                                    required
                                                >
                                                    <option value="">Select...</option>
                                                    <option value="YES">Yes</option>
                                                    <option value="NO">No</option>
                                                </TextField>
                                            </Grid>
                                        )}
                                    </Grid>
                                </TabPanel>

                                {/* Services Tab */}
                                {this.state.showServicesTab && (
                                    <TabPanel value={this.state.currentTab} index={this.getTabIndex("Services")}>


                                        {/* Show service-specific errors if present */}
                                        {this.state.formErrors?.services && (
                                            <Box
                                                sx={{
                                                    backgroundColor: '#ffebee',
                                                    padding: '8px 16px',
                                                    borderRadius: '4px',
                                                    marginBottom: '16px',
                                                    border: '1px solid #ef9a9a'
                                                }}
                                            >
                                                <Typography variant="body2" color="error">
                                                    {this.state.formErrors.services}
                                                </Typography>
                                            </Box>
                                        )}

                                        <Grid container spacing={3}>
                                            {/* Selected Services Table */}
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Selected Services
                                                    {(this.props.type === "H" || this.props.type === "A") && (
                                                        <span style={{ color: '#b0170c', marginLeft: '5px' }}>*</span>
                                                    )}
                                                </Typography>
                                                {this.props.type === "H" && (() => {
                                                    // Check if we currently have any active services
                                                    const currentServices = this.state.editLocation?.selectedServices || [];
                                                    const deletedServices = this.state.deletedServices || [];
                                                    const activeServices = currentServices.filter(
                                                        service => !deletedServices.includes(service)
                                                    );


                                                })()}
                                                <Paper variant="outlined" style={{ height: '200px', overflow: 'auto' }}>
                                                    {(editLocation.selectedServices && editLocation.selectedServices.length > 0) || this.state.deletedServices.length > 0 ? (
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell style={{ fontWeight: 'bold', width: '85%' }}>Service Name</TableCell>
                                                                    <TableCell style={{ fontWeight: 'bold', width: '15%', textAlign: 'right', paddingRight: '24px' }}>Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {/* Active services */}
                                                                {editLocation.selectedServices
                                                                    .filter(service => !this.state.deletedServices.includes(service))
                                                                    .map((service, index) => (
                                                                        <TableRow key={`service-${index}`}>
                                                                            <TableCell>{service}</TableCell>
                                                                            <TableCell style={{ textAlign: 'right', paddingRight: '8px' }}>
                                                                                <Tooltip title="Remove service" placement="top">
                                                                                    <IconButton
                                                                                        size="small"
                                                                                        onClick={() => this.handleRemoveService(service)}
                                                                                        aria-label={`Remove ${service}`}
                                                                                    >
                                                                                        <HighlightOffIcon fontSize="small" />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))}

                                                                {/* Deleted services with strike-through */}
                                                                {this.state.deletedServices.map((service, index) => (
                                                                    <TableRow key={`deleted-service-${index}`} style={{ backgroundColor: '#ffebee' }}>
                                                                        <TableCell>
                                                                            <span style={{ textDecoration: 'line-through', color: '#999' }}>
                                                                                {service}
                                                                            </span>
                                                                        </TableCell>
                                                                        <TableCell style={{ textAlign: 'right', paddingRight: '8px' }}>
                                                                            <Tooltip title="Undo delete" placement="top">
                                                                                <IconButton
                                                                                    size="small"
                                                                                    onClick={() => this.handleUndoServiceDelete(service)}
                                                                                    aria-label={`Undo delete ${service}`}
                                                                                    color="primary"
                                                                                >
                                                                                    <RestoreIcon fontSize="small" />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    ) : (
                                                        <Box p={3} textAlign="center">
                                                            <Typography variant="body2" color="textSecondary">
                                                                No services selected. Use the list below to add services.
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Paper>
                                            </Grid>


                                            {/* Available Services List with Search */}
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Available Services
                                                </Typography>

                                                {/* Search field for services */}
                                                <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    placeholder="Search services..."
                                                    value={this.state.serviceSearchTerm}
                                                    onChange={this.handleServiceSearchChange}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <span style={{ marginRight: 8 }}>🔍</span>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    style={{ marginBottom: '8px' }}
                                                />

                                                <Paper variant="outlined" style={{ height: '250px', overflow: 'auto' }}>
                                                    {this.state.loadingServices ? (
                                                        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                                                            <CircularProgress size={24} />
                                                            <Typography variant="body2" style={{ marginLeft: 10 }}>
                                                                Loading services...
                                                            </Typography>
                                                        </Box>
                                                    ) : (
                                                        <List dense>
                                                            {this.state.serviceOptions
                                                                .filter(option =>
                                                                    option.label.toLowerCase().includes(this.state.serviceSearchTerm.toLowerCase())
                                                                )
                                                                .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }))
                                                                .map((option) => (
                                                                    <ListItem
                                                                        key={option.id}
                                                                        button
                                                                        onClick={() => this.handleAddService(option.value)}
                                                                    >
                                                                        <ListItemText primary={option.label} />
                                                                        <ListItemSecondaryAction style={{ right: '16px' }}>
                                                                            <Tooltip title="Add service" placement="top">
                                                                                <IconButton
                                                                                    edge="end"
                                                                                    size="small"
                                                                                    onClick={() => this.handleAddService(option.value)}
                                                                                    aria-label={`Add ${option.label}`}
                                                                                >
                                                                                    <AddIcon fontSize="small" />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </ListItemSecondaryAction>
                                                                    </ListItem>
                                                                ))}

                                                            {/* Show message when no results match search */}
                                                            {this.state.serviceOptions.filter(option =>
                                                                option.label.toLowerCase().includes(this.state.serviceSearchTerm.toLowerCase())
                                                            ).length === 0 && (
                                                                    <ListItem>
                                                                        <ListItemText
                                                                            primary={
                                                                                this.state.serviceSearchTerm ?
                                                                                    `No services match "${this.state.serviceSearchTerm}"` :
                                                                                    "No available services"
                                                                            }
                                                                            style={{ color: 'gray', fontStyle: 'italic' }}
                                                                        />
                                                                    </ListItem>
                                                                )}
                                                        </List>
                                                    )}
                                                </Paper>
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                )}
                                {/* Specialties Tab - Only for non-hospital facilities */}
                                {this.state.showSpecialtiesTab && (
                                    <TabPanel value={this.state.currentTab} index={this.getTabIndex("Specialties")}>
                                        {this.state.formErrors?.specialties && (
                                            <Box
                                                sx={{
                                                    backgroundColor: '#ffebee',
                                                    padding: '8px 16px',
                                                    borderRadius: '4px',
                                                    marginBottom: '16px',
                                                    border: '1px solid #ef9a9a'
                                                }}
                                            >
                                                <Typography variant="body2" color="error">
                                                    {this.state.formErrors.specialties}
                                                </Typography>
                                            </Box>
                                        )}
                                        <Grid container spacing={3}>
                                            {/* Selected Specialties Table */}
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Selected Specialties
                                                    {this.props.type === "A" && this.hasPhysicianGroupParticipation() && (
                                                        <span style={{ color: '#b0170c', marginLeft: '5px' }}>*</span>
                                                    )}
                                                </Typography>
                                                <Paper variant="outlined" style={{ height: '200px', overflow: 'auto' }}>
                                                    {(editLocation.selectedSpecialties && editLocation.selectedSpecialties.length > 0) || this.state.deletedSpecialties.length > 0 ? (
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell style={{ fontWeight: 'bold', width: '85%' }}>Specialty Name</TableCell>
                                                                    <TableCell style={{ fontWeight: 'bold', width: '15%', textAlign: 'right', paddingRight: '24px' }}>Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {/* Active specialties */}
                                                                {editLocation.selectedSpecialties
                                                                    .filter(specialty => !this.state.deletedSpecialties.includes(specialty))
                                                                    .map((specialty, index) => (
                                                                        <TableRow key={`specialty-${index}`}>
                                                                            <TableCell>{specialty}</TableCell>
                                                                            <TableCell style={{ textAlign: 'right', paddingRight: '8px' }}>
                                                                                <Tooltip title="Remove specialty" placement="top">
                                                                                    <IconButton
                                                                                        size="small"
                                                                                        onClick={() => this.handleRemoveSpecialty(specialty)}
                                                                                        aria-label={`Remove ${specialty}`}
                                                                                    >
                                                                                        <HighlightOffIcon fontSize="small" />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))}

                                                                {/* Deleted specialties with strike-through */}
                                                                {this.state.deletedSpecialties.map((specialty, index) => (
                                                                    <TableRow key={`deleted-specialty-${index}`} style={{ backgroundColor: '#ffebee' }}>
                                                                        <TableCell>
                                                                            <span style={{ textDecoration: 'line-through', color: '#999' }}>
                                                                                {specialty}
                                                                            </span>
                                                                        </TableCell>
                                                                        <TableCell style={{ textAlign: 'right', paddingRight: '8px' }}>
                                                                            <Tooltip title="Undo delete" placement="top">
                                                                                <IconButton
                                                                                    size="small"
                                                                                    onClick={() => this.handleUndoSpecialtyDelete(specialty)}
                                                                                    aria-label={`Undo delete ${specialty}`}
                                                                                    color="primary"
                                                                                >
                                                                                    <RestoreIcon fontSize="small" />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    ) : (
                                                        <Box p={3} textAlign="center">
                                                            <Typography variant="body2" color="textSecondary">
                                                                No specialties selected. Use the list below to add specialties.
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Paper>
                                            </Grid>

                                            {/* Available Specialties List with Search */}
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Available Specialties
                                                </Typography>

                                                {/* Search field for specialties */}
                                                <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    placeholder="Search specialties..."
                                                    value={this.state.specialtySearchTerm}
                                                    onChange={this.handleSpecialtySearchChange}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <span style={{ marginRight: 8 }}>🔍</span>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    style={{ marginBottom: '8px' }}
                                                />

                                                <Paper variant="outlined" style={{ height: '250px', overflow: 'auto' }}>
                                                    {this.state.loadingSpecialties ? (
                                                        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                                                            <CircularProgress size={24} />
                                                            <Typography variant="body2" style={{ marginLeft: 10 }}>
                                                                Loading specialties...
                                                            </Typography>
                                                        </Box>
                                                    ) : (
                                                        <List dense>
                                                            {this.state.specialtyOptions
                                                                .filter(option =>
                                                                    option.label.toLowerCase().includes(this.state.specialtySearchTerm.toLowerCase())
                                                                )
                                                                .map((option) => (
                                                                    <ListItem
                                                                        key={option.id}
                                                                        button
                                                                        onClick={() => this.handleAddSpecialty(option.value)}
                                                                    >
                                                                        <ListItemText primary={option.label} />
                                                                        <ListItemSecondaryAction style={{ right: '16px' }}>
                                                                            <Tooltip title="Add specialty" placement="top">
                                                                                <IconButton
                                                                                    edge="end"
                                                                                    size="small"
                                                                                    onClick={() => this.handleAddSpecialty(option.value)}
                                                                                    aria-label={`Add ${option.label}`}
                                                                                >
                                                                                    <AddIcon fontSize="small" />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </ListItemSecondaryAction>
                                                                    </ListItem>
                                                                ))}

                                                            {/* Show message when no results match search */}
                                                            {this.state.specialtyOptions.filter(option =>
                                                                option.label.toLowerCase().includes(this.state.specialtySearchTerm.toLowerCase())
                                                            ).length === 0 && (
                                                                    <ListItem>
                                                                        <ListItemText
                                                                            primary={
                                                                                this.state.specialtySearchTerm ?
                                                                                    `No specialties match "${this.state.specialtySearchTerm}"` :
                                                                                    "No available specialties"
                                                                            }
                                                                            style={{ color: 'gray', fontStyle: 'italic' }}
                                                                        />
                                                                    </ListItem>
                                                                )}
                                                        </List>
                                                    )}
                                                </Paper>
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                )}

                                {/* Focus Areas Tab */}
                                {this.state.showFocusAreasTab && (
                                    <TabPanel value={this.state.currentTab} index={this.getTabIndex("Focus Areas")}>
                                        {(this.state.formErrors?.focusAreas || this.state.formErrors?.details) && (
                                            <Box
                                                sx={{
                                                    backgroundColor: '#ffebee',
                                                    padding: '8px 16px',
                                                    borderRadius: '4px',
                                                    marginBottom: '16px',
                                                    border: '1px solid #ef9a9a'
                                                }}
                                            >
                                                <Typography variant="body2" color="error">
                                                    {this.state.formErrors?.focusAreas || this.state.formErrors?.details}
                                                </Typography>
                                            </Box>
                                        )}
                                        <Grid container spacing={3}>
                                            {/* Selected Focus Areas Table */}
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Selected Focus Areas
                                                </Typography>
                                                <Paper variant="outlined" style={{ height: '200px', overflow: 'auto' }}>
                                                    {(editLocation.focusAreas && editLocation.focusAreas.length > 0) || this.state.deletedFocuses.length > 0 ? (
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell style={{ fontWeight: 'bold', width: '85%' }}>Focus Area</TableCell>
                                                                    <TableCell style={{ fontWeight: 'bold', width: '15%', textAlign: 'right', paddingRight: '24px' }}>Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {/* Active focus areas */}
                                                                {editLocation.focusAreas
                                                                    .filter(focus => !this.state.deletedFocuses.includes(focus))
                                                                    .map((focus, index) => (
                                                                        <TableRow key={`focus-${index}`}>
                                                                            <TableCell>{focus}</TableCell>
                                                                            <TableCell style={{ textAlign: 'right', paddingRight: '8px' }}>
                                                                                <Tooltip title="Remove focus area" placement="top">
                                                                                    <IconButton
                                                                                        size="small"
                                                                                        onClick={() => this.handleRemoveFocus(focus)}
                                                                                        aria-label={`Remove ${focus}`}
                                                                                    >
                                                                                        <HighlightOffIcon fontSize="small" />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))}

                                                                {/* Deleted focus areas with strike-through */}
                                                                {this.state.deletedFocuses.map((focus, index) => (
                                                                    <TableRow key={`deleted-focus-${index}`} style={{ backgroundColor: '#ffebee' }}>
                                                                        <TableCell>
                                                                            <span style={{ textDecoration: 'line-through', color: '#999' }}>
                                                                                {focus}
                                                                            </span>
                                                                        </TableCell>
                                                                        <TableCell style={{ textAlign: 'right', paddingRight: '8px' }}>
                                                                            <Tooltip title="Undo delete" placement="top">
                                                                                <IconButton
                                                                                    size="small"
                                                                                    onClick={() => this.handleUndoFocusDelete(focus)}
                                                                                    aria-label={`Undo delete ${focus}`}
                                                                                    color="primary"
                                                                                >
                                                                                    <RestoreIcon fontSize="small" />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    ) : (
                                                        <Box p={3} textAlign="center">
                                                            <Typography variant="body2" color="textSecondary">
                                                                No focus areas selected. Use the list below to add focus areas.
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Paper>
                                            </Grid>

                                            {/* Available Focus Areas List with Search */}
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Available Focus Areas
                                                </Typography>

                                                {/* Search field for focus areas */}
                                                <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    placeholder="Search focus areas..."
                                                    value={this.state.focusSearchTerm}
                                                    onChange={this.handleFocusSearchChange}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <span style={{ marginRight: 8 }}>🔍</span>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    style={{ marginBottom: '8px' }}
                                                />

                                                <Paper variant="outlined" style={{ height: '250px', overflow: 'auto' }}>
                                                    {this.state.loadingFocusAreas ? (
                                                        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                                                            <CircularProgress size={24} />
                                                            <Typography variant="body2" style={{ marginLeft: 10 }}>
                                                                Loading focus areas...
                                                            </Typography>
                                                        </Box>
                                                    ) : (
                                                        <List dense>
                                                            {this.state.focusOptions
                                                                .filter(option => {
                                                                    // Only filter out items that are selected and not deleted
                                                                    const isSelected = editLocation.focusAreas?.includes(option.value);
                                                                    const isDeleted = this.state.deletedFocuses.includes(option.value);
                                                                    return !(isSelected && !isDeleted) &&
                                                                        option.label.toLowerCase().includes(this.state.focusSearchTerm.toLowerCase());
                                                                })
                                                                .map((option) => (
                                                                    <ListItem
                                                                        key={option.id}
                                                                        button
                                                                        onClick={() => this.handleAddFocus(option.value)}
                                                                    >
                                                                        <ListItemText primary={option.label} />
                                                                        <ListItemSecondaryAction style={{ right: '16px' }}>
                                                                            <Tooltip title="Add focus area" placement="top">
                                                                                <IconButton
                                                                                    edge="end"
                                                                                    size="small"
                                                                                    onClick={() => this.handleAddFocus(option.value)}
                                                                                    aria-label={`Add ${option.label}`}
                                                                                >
                                                                                    <AddIcon fontSize="small" />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </ListItemSecondaryAction>
                                                                    </ListItem>
                                                                ))}

                                                            {/* Show message when no results match search */}
                                                            {this.state.focusOptions.filter(option => {
                                                                const isSelected = editLocation.focusAreas?.includes(option.value);
                                                                const isDeleted = this.state.deletedFocuses.includes(option.value);
                                                                return !(isSelected && !isDeleted) &&
                                                                    option.label.toLowerCase().includes(this.state.focusSearchTerm.toLowerCase());
                                                            }).length === 0 && (
                                                                    <ListItem>
                                                                        <ListItemText
                                                                            primary={
                                                                                this.state.focusSearchTerm ?
                                                                                    `No focus areas match "${this.state.focusSearchTerm}"` :
                                                                                    "No available focus areas"
                                                                            }
                                                                            style={{ color: 'gray', fontStyle: 'italic' }}
                                                                        />
                                                                    </ListItem>
                                                                )}
                                                        </List>
                                                    )}
                                                </Paper>
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                )}
                                {/* Languages Tab */}
                                <TabPanel value={this.state.currentTab} index={this.getTabIndex("Languages")}>
                                    {this.state.formErrors?.languages && (
                                        <Box
                                            sx={{
                                                backgroundColor: '#ffebee',
                                                padding: '8px 16px',
                                                borderRadius: '4px',
                                                marginBottom: '16px',
                                                border: '1px solid #ef9a9a'
                                            }}
                                        >
                                            <Typography variant="body2" color="error">
                                                {this.state.formErrors.languages}
                                            </Typography>
                                        </Box>
                                    )}
                                    <Grid container spacing={3}>
                                        {/* Selected Languages Table */}
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Selected Languages
                                            </Typography>
                                            <Paper variant="outlined" style={{ height: '200px', overflow: 'auto' }}>
                                                {(editLocation.selectedLanguages && editLocation.selectedLanguages.length > 0) || this.state.deletedLanguages.length > 0 ? (
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell style={{ fontWeight: 'bold', width: '85%' }}>Language</TableCell>
                                                                <TableCell style={{ fontWeight: 'bold', width: '15%', textAlign: 'right', paddingRight: '24px' }}>Action</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {/* Active languages */}
                                                            {editLocation.selectedLanguages
                                                                .filter(language => !this.state.deletedLanguages.includes(language))
                                                                .map((language, index) => (
                                                                    <TableRow key={`language-${index}`}>
                                                                        <TableCell>{language}</TableCell>
                                                                        <TableCell style={{ textAlign: 'right', paddingRight: '8px' }}>
                                                                            <Tooltip title="Remove language" placement="top">
                                                                                <IconButton
                                                                                    size="small"
                                                                                    onClick={() => this.handleRemoveLanguage(language)}
                                                                                    aria-label={`Remove ${language}`}
                                                                                >
                                                                                    <HighlightOffIcon fontSize="small" />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}

                                                            {/* Deleted languages with strike-through */}
                                                            {this.state.deletedLanguages.map((language, index) => (
                                                                <TableRow key={`deleted-language-${index}`} style={{ backgroundColor: '#ffebee' }}>
                                                                    <TableCell>
                                                                        <span style={{ textDecoration: 'line-through', color: '#999' }}>
                                                                            {language}
                                                                        </span>
                                                                    </TableCell>
                                                                    <TableCell style={{ textAlign: 'right', paddingRight: '8px' }}>
                                                                        <Tooltip title="Undo delete" placement="top">
                                                                            <IconButton
                                                                                size="small"
                                                                                onClick={() => this.handleUndoLanguageDelete(language)}
                                                                                aria-label={`Undo delete ${language}`}
                                                                                color="primary"
                                                                            >
                                                                                <RestoreIcon fontSize="small" />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                ) : (
                                                    <Box p={3} textAlign="center">
                                                        <Typography variant="body2" color="textSecondary">
                                                            No languages selected. Use the list below to add languages.
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Paper>
                                        </Grid>

                                        {/* Available Languages List with Search */}
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Available Languages
                                            </Typography>

                                            {/* Search field for languages */}
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                size="small"
                                                placeholder="Search languages..."
                                                value={this.state.languageSearchTerm}
                                                onChange={this.handleLanguageSearchChange}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <span style={{ marginRight: 8 }}>🔍</span>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                style={{ marginBottom: '8px' }}
                                            />

                                            <Paper variant="outlined" style={{ height: '250px', overflow: 'auto' }}>
                                                {this.state.loadingLanguages ? (
                                                    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                                                        <CircularProgress size={24} />
                                                        <Typography variant="body2" style={{ marginLeft: 10 }}>
                                                            Loading languages...
                                                        </Typography>
                                                    </Box>
                                                ) : (
                                                    <List dense>
                                                        {this.state.languageOptions
                                                            .filter(option => {
                                                                // Only filter out items that are selected and not deleted
                                                                const isSelected = editLocation.selectedLanguages?.includes(option.value);
                                                                const isDeleted = this.state.deletedLanguages.includes(option.value);
                                                                return !(isSelected && !isDeleted) &&
                                                                    option.label.toLowerCase().includes(this.state.languageSearchTerm.toLowerCase());
                                                            })
                                                            .map((option) => (
                                                                <ListItem
                                                                    key={option.id}
                                                                    button
                                                                    onClick={() => this.handleAddLanguage(option.value)}
                                                                >
                                                                    <ListItemText primary={option.label} />
                                                                    <ListItemSecondaryAction style={{ right: '16px' }}>
                                                                        <Tooltip title="Add language" placement="top">
                                                                            <IconButton
                                                                                edge="end"
                                                                                size="small"
                                                                                onClick={() => this.handleAddLanguage(option.value)}
                                                                                aria-label={`Add ${option.label}`}
                                                                            >
                                                                                <AddIcon fontSize="small" />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </ListItemSecondaryAction>
                                                                </ListItem>
                                                            ))}

                                                        {/* Show message when no results match search */}
                                                        {this.state.languageOptions.filter(option => {
                                                            const isSelected = editLocation.selectedLanguages?.includes(option.value);
                                                            const isDeleted = this.state.deletedLanguages.includes(option.value);
                                                            return !(isSelected && !isDeleted) &&
                                                                option.label.toLowerCase().includes(this.state.languageSearchTerm.toLowerCase());
                                                        }).length === 0 && (
                                                                <ListItem>
                                                                    <ListItemText
                                                                        primary={
                                                                            this.state.languageSearchTerm ?
                                                                                `No languages match "${this.state.languageSearchTerm}"` :
                                                                                "No available languages"
                                                                        }
                                                                        style={{ color: 'gray', fontStyle: 'italic' }}
                                                                    />
                                                                </ListItem>
                                                            )}
                                                    </List>
                                                )}
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                </TabPanel>

                            </>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeEditDlg} variant="outlined" aria-label="Cancel edit">
                            Cancel
                        </Button>
                        <Button onClick={this.handleSaveEdit} color="primary" variant="contained" aria-label="Save location changes">
                            Save
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Delete Confirmation Dialog using the reusable component */}
                <ConfirmationDialog
                    open={showDeleteConfirmDialog}
                    title="Confirm Delete Location"
                    message={locationToDelete && !this.state.originalLocations.some(
                        loc => loc.flfFaclocId === locationToDelete.flfFaclocId
                    ) ? "Are you sure you want to delete this newly added location?" : "Are you sure you want to delete this location?"}
                    detailsComponent={
                        locationToDelete && (
                            <>
                                {!this.state.originalLocations.some(
                                    loc => loc.flfFaclocId === locationToDelete.flfFaclocId
                                ) && (
                                        <Typography variant="subtitle2" style={{ color: '#f44336', marginBottom: '8px' }}>
                                            <strong>This is a newly added location that hasn't been saved to the server.</strong>
                                        </Typography>
                                    )}
                                <Typography variant="subtitle2">
                                    <strong>Office Name:</strong> {locationToDelete.faclocDirectoryLocName}
                                </Typography>
                                <Typography variant="subtitle2">
                                    <strong>Address:</strong> {locationToDelete.address}
                                </Typography>
                                <Typography variant="subtitle2">
                                    <strong>Phone:</strong> {locationToDelete.faclocDirectoryPhoneNbr}
                                </Typography>
                            </>
                        )
                    }
                    onConfirm={this.handleDeleteLocation}
                    onCancel={this.handleCancelDelete}
                    confirmText="Delete"
                    confirmColor="secondary"
                    severity="error"
                />

                {/* Changes Summary Dialog */}
                <Dialog
                    open={this.state.showChangesSummaryDialog}
                    onClose={this.handleCloseChangesSummary}
                    maxWidth="xl"
                    fullWidth
                >
                    <DialogTitle>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="h6">Review Location Changes</Typography>
                        </Box>
                    </DialogTitle>
                    <DialogContent>
                        {this.state.changesSummary.newLocations.length === 0 &&
                            this.state.changesSummary.modifiedLocations.length === 0 &&
                            this.state.changesSummary.deletedLocations.length === 0 ? (
                            <Typography>No changes to review.</Typography>
                        ) : (
                            <div>
                                {/* New Locations Section */}
                                {this.state.changesSummary.newLocations.length > 0 && (
                                    <div style={{ marginBottom: '20px' }}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: '#4caf50', marginBottom: '8px' }}>
                                            New Locations ({this.state.changesSummary.newLocations.length})
                                        </Typography>
                                        <div style={{ width: '100%', overflowX: 'auto', overflowY: 'auto', maxHeight: '300px' }}>
                                            <Table size="small" style={{ tableLayout: 'fixed', width: '100%' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ fontWeight: 'bold', width: '10%' }}>Name</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '6%' }}>NPI</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '14%' }}>Address</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '6%' }}>Phone</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '6%' }}>Fax</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '8%' }}>Email</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '6%' }}>Accepting WC</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '8%' }}>WC Date</TableCell>
                                                        {this.state.showServicesTab && (
                                                            <TableCell style={{ fontWeight: 'bold', width: '11%' }}>Services</TableCell>
                                                        )}
                                                        {this.state.showSpecialtiesTab && (
                                                            <TableCell style={{ fontWeight: 'bold', width: '11%' }}>Specialties</TableCell>
                                                        )}

                                                        {!isHospital && (
                                                            <TableCell style={{ fontWeight: 'bold', width: '11%' }}>Focus Areas</TableCell>
                                                        )}
                                                        <TableCell style={{ fontWeight: 'bold', width: '11%' }}>Languages</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.state.changesSummary.newLocations.map((location, index) => (
                                                        <TableRow key={`new-${index}`} style={{ backgroundColor: '#e8f5e9' }}>
                                                            <TableCell style={{ wordBreak: 'break-word' }}>{location.faclocDirectoryLocName}</TableCell>
                                                            <TableCell style={{ wordBreak: 'break-word' }}>{location.faclocNpi}</TableCell>
                                                            <TableCell style={{ wordBreak: 'break-word' }}>{location.address}</TableCell>
                                                            <TableCell>{location.faclocDirectoryPhoneNbr}</TableCell>
                                                            <TableCell>{location.faclocFaxNbr}</TableCell>
                                                            <TableCell style={{ wordBreak: 'break-word' }}>{location.faclocEmailAddress}</TableCell>
                                                            <TableCell>{formatYesNo(location.flfAcceptWcPatients)}</TableCell>
                                                            <TableCell>
                                                                {location.flfAcceptWcPatDate
                                                                    ? new Date(location.flfAcceptWcPatDate).toLocaleDateString('en-US', {
                                                                        year: 'numeric',
                                                                        month: '2-digit',
                                                                        day: '2-digit'
                                                                    })
                                                                    : ''}
                                                            </TableCell>
                                                            {this.state.showServicesTab && (
                                                                <TableCell style={{ wordBreak: 'break-word' }}>{formatItems(location.services)}</TableCell>
                                                            )}
                                                            {this.state.showSpecialtiesTab && (
                                                                <TableCell style={{ wordBreak: 'break-word' }}>{formatItems(location.specialties)}</TableCell>
                                                            )}

                                                            {!isHospital && (
                                                                <TableCell style={{ wordBreak: 'break-word' }}>{formatFocusAreasComplete(location.details)}</TableCell>
                                                            )}
                                                            <TableCell style={{ wordBreak: 'break-word' }}>{formatItems(location.languages)}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </div>
                                    </div>
                                )}

                                {/* Modified Locations Section */}
                                {this.state.changesSummary.modifiedLocations.length > 0 && (
                                    <div style={{ marginBottom: '20px' }}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: '#2196f3', marginBottom: '8px' }}>
                                            Modified Locations ({this.state.changesSummary.modifiedLocations.length})
                                        </Typography>

                                        {/* Explanation message */}
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                marginBottom: '8px',
                                                backgroundColor: '#e3f2fd',
                                                padding: '6px 12px',
                                                borderRadius: '4px'
                                            }}
                                        >
                                            <span
                                                style={{
                                                    display: 'inline-block',
                                                    width: '16px',
                                                    height: '16px',
                                                    backgroundColor: '#ffeb3b40',
                                                    border: '1px solid #ffeb3b',
                                                    marginRight: '8px',
                                                    borderRadius: '2px'
                                                }}
                                            ></span>
                                            <Typography variant="body2" style={{ fontStyle: 'italic' }}>
                                                Highlighted values indicate modified fields
                                            </Typography>
                                        </Box>

                                        <div style={{ width: '100%', overflowX: 'auto', overflowY: 'auto', maxHeight: '300px' }}>
                                            <Table size="small" style={{ tableLayout: 'fixed', width: '100%' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ fontWeight: 'bold', width: '10%' }}>Name</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '6%' }}>NPI</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '14%' }}>Address</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '6%' }}>Phone</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '6%' }}>Fax</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '8%' }}>Email</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '6%' }}>Accepting WC</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '8%' }}>WC Date</TableCell>
                                                        {this.state.showServicesTab && (
                                                            <TableCell style={{ fontWeight: 'bold', width: '11%' }}>Services</TableCell>
                                                        )}
                                                        {this.state.showSpecialtiesTab && (
                                                            <TableCell style={{ fontWeight: 'bold', width: '11%' }}>Specialties</TableCell>
                                                        )}

                                                        {!isHospital && (
                                                            <TableCell style={{ fontWeight: 'bold', width: '11%' }}>Focus Areas</TableCell>
                                                        )}
                                                        <TableCell style={{ fontWeight: 'bold', width: '11%' }}>Languages</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.state.changesSummary.modifiedLocations.map((change, index) => {
                                                        // Helper function to determine if a field has changed
                                                        const hasChanged = (field) => {
                                                            // Special handling for address field
                                                            if (field === 'address' || field === 'addressString') {
                                                                const origAddress = change.original.address || change.original.addressString || '';
                                                                const modAddress = change.modified.address || change.modified.addressString || '';

                                                                const normalizeAddress = (addr) => {
                                                                    return addr
                                                                        .replace(/\n/g, ' ')
                                                                        .replace(/\s+/g, ' ')
                                                                        .replace(/\s*,\s*/g, ',')
                                                                        .replace(/\s*-\s*/g, '-')
                                                                        .trim()
                                                                        .toLowerCase();
                                                                };

                                                                return normalizeAddress(origAddress) !== normalizeAddress(modAddress);
                                                            }
                                                            // Special handling for focusAreas/details which is an array
                                                            if (field === 'details') {
                                                                const normalizeFocus = (details) => {
                                                                    if (!details || !Array.isArray(details)) return [];

                                                                    const focusDescriptions = details.map(detail => {
                                                                        if (typeof detail === 'string') return detail;

                                                                        const desc = detail.focusShortDesc ||
                                                                            detail.focusName ||
                                                                            detail.value ||
                                                                            detail.focusDesc ||
                                                                            '';

                                                                        return desc;
                                                                    })
                                                                        .filter(Boolean)
                                                                        .map(desc => desc.trim().toLowerCase())
                                                                        .sort();

                                                                    return focusDescriptions;
                                                                };

                                                                const origFocus = normalizeFocus(change.original.details || change.original.focuses || []);
                                                                const modFocus = normalizeFocus(change.modified.details || change.modified.focuses || []);

                                                                return JSON.stringify(origFocus) !== JSON.stringify(modFocus);
                                                            }

                                                            // Special handling for services, specialties, and languages arrays
                                                            if (field === 'services' || field === 'specialties' || field === 'languages') {
                                                                const original = change.original[field] || [];
                                                                const modified = change.modified[field] || [];

                                                                const normalizeItems = (items) => {
                                                                    return items.map(item => {
                                                                        const desc = item.serviceDesc ||
                                                                            item.fsrShortDesc ||
                                                                            item.specialtyDesc ||
                                                                            item.specDesc ||
                                                                            item.languageDesc ||
                                                                            item.lngLanguageName ||
                                                                            (typeof item === 'string' ? item : '');

                                                                        return desc.trim().toLowerCase();
                                                                    }).filter(Boolean).sort();
                                                                };

                                                                const origDescs = normalizeItems(original);
                                                                const modDescs = normalizeItems(modified);

                                                                if (origDescs.length !== modDescs.length) return true;

                                                                for (let i = 0; i < origDescs.length; i++) {
                                                                    if (origDescs[i] !== modDescs[i]) return true;
                                                                }

                                                                return false;
                                                            }
                                                            // Special handling for flfAcceptWcPatients
                                                            if (field === 'flfAcceptWcPatients') {
                                                                return formatYesNo(change.original[field]) !== formatYesNo(change.modified[field]);
                                                            }


                                                            if (field === 'flfAcceptWcPatDate') {
                                                                const origDate = change.original[field] ? new Date(change.original[field]).toLocaleDateString('en-US') : '';
                                                                const modDate = change.modified[field] ? new Date(change.modified[field]).toLocaleDateString('en-US') : '';
                                                                return origDate !== modDate;
                                                            }

                                                            return change.original[field] !== change.modified[field];
                                                        };

                                                        // Style for changed values
                                                        const changedStyle = {
                                                            backgroundColor: '#ffeb3b40',
                                                            fontWeight: 'bold',
                                                            wordBreak: 'break-word'
                                                        };

                                                        // Style for unchanged values
                                                        const unchangedStyle = {
                                                            wordBreak: 'break-word'
                                                        };

                                                        return (
                                                            <TableRow key={`mod-${index}`} style={{ backgroundColor: '#e3f2fd' }}>
                                                                <TableCell style={hasChanged('faclocDirectoryLocName') ? changedStyle : unchangedStyle}>
                                                                    {change.modified.faclocDirectoryLocName}
                                                                </TableCell>
                                                                <TableCell style={hasChanged('faclocNpi') ? changedStyle : unchangedStyle}>
                                                                    {change.modified.faclocNpi}
                                                                </TableCell>
                                                                <TableCell style={hasChanged('address') ? changedStyle : unchangedStyle}>
                                                                    {change.modified.address}
                                                                </TableCell>
                                                                <TableCell style={hasChanged('faclocDirectoryPhoneNbr') ? changedStyle : unchangedStyle}>
                                                                    {change.modified.faclocDirectoryPhoneNbr}
                                                                </TableCell>
                                                                <TableCell style={hasChanged('faclocFaxNbr') ? changedStyle : unchangedStyle}>
                                                                    {change.modified.faclocFaxNbr}
                                                                </TableCell>
                                                                <TableCell style={hasChanged('faclocEmailAddress') ? changedStyle : unchangedStyle}>
                                                                    {change.modified.faclocEmailAddress}
                                                                </TableCell>
                                                                <TableCell style={hasChanged('flfAcceptWcPatients') ? changedStyle : unchangedStyle}>
                                                                    {formatYesNo(change.modified.flfAcceptWcPatients)}
                                                                </TableCell>
                                                                <TableCell style={hasChanged('flfAcceptWcPatDate') ? changedStyle : unchangedStyle}>
                                                                    {change.modified.flfAcceptWcPatDate
                                                                        ? new Date(change.modified.flfAcceptWcPatDate).toLocaleDateString('en-US', {
                                                                            year: 'numeric',
                                                                            month: '2-digit',
                                                                            day: '2-digit'
                                                                        })
                                                                        : ''}
                                                                </TableCell>
                                                                {this.state.showServicesTab && (
                                                                    <TableCell style={hasChanged('services') ? changedStyle : unchangedStyle}>
                                                                        {formatItems(change.modified.services)}
                                                                    </TableCell>
                                                                )}
                                                                {this.state.showSpecialtiesTab && (
                                                                    <TableCell style={hasChanged('specialties') ? changedStyle : unchangedStyle}>
                                                                        {formatItems(change.modified.specialties)}
                                                                    </TableCell>
                                                                )}

                                                                {!isHospital && (
                                                                    <TableCell style={hasChanged('details') ? changedStyle : unchangedStyle}>
                                                                        {formatFocusAreasComplete(change.modified.details)}
                                                                    </TableCell>
                                                                )}
                                                                <TableCell style={hasChanged('languages') ? changedStyle : unchangedStyle}>
                                                                    {formatItems(change.modified.languages)}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </div>
                                    </div>
                                )}

                                {/* Deleted Locations Section */}
                                {this.state.changesSummary.deletedLocations.length > 0 && (
                                    <div style={{ marginBottom: '20px' }}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: '#f44336', marginBottom: '8px' }}>
                                            Deleted Locations ({this.state.changesSummary.deletedLocations.length})
                                        </Typography>
                                        <div style={{ width: '100%', overflowX: 'auto', overflowY: 'auto', maxHeight: '300px' }}>
                                            <Table size="small" style={{ tableLayout: 'fixed', width: '100%' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ fontWeight: 'bold', width: '10%' }}>Name</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '6%' }}>NPI</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '14%' }}>Address</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '6%' }}>Phone</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '6%' }}>Fax</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '8%' }}>Email</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '6%' }}>Accepting WC</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', width: '8%' }}>WC Date</TableCell>
                                                        {this.state.showServicesTab && (
                                                            <TableCell style={{ fontWeight: 'bold', width: '11%' }}>Services</TableCell>
                                                        )}
                                                        {this.state.showSpecialtiesTab && (
                                                            <TableCell style={{ fontWeight: 'bold', width: '11%' }}>Specialties</TableCell>
                                                        )}

                                                        {!isHospital && (
                                                            <TableCell style={{ fontWeight: 'bold', width: '11%' }}>Focus Areas</TableCell>
                                                        )}
                                                        <TableCell style={{ fontWeight: 'bold', width: '11%' }}>Languages</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.state.changesSummary.deletedLocations.map((location, index) => (
                                                        <TableRow key={`del-${index}`} style={{ backgroundColor: '#ffebee' }}>
                                                            <TableCell style={{ wordBreak: 'break-word' }}>{location.faclocDirectoryLocName}</TableCell>
                                                            <TableCell style={{ wordBreak: 'break-word' }}>{location.faclocNpi}</TableCell>
                                                            <TableCell style={{ wordBreak: 'break-word' }}>{location.address}</TableCell>
                                                            <TableCell>{location.faclocDirectoryPhoneNbr}</TableCell>
                                                            <TableCell>{location.faclocFaxNbr}</TableCell>
                                                            <TableCell style={{ wordBreak: 'break-word' }}>{location.faclocEmailAddress}</TableCell>
                                                            <TableCell>{formatYesNo(location.flfAcceptWcPatients)}</TableCell>
                                                            <TableCell>
                                                                {location.flfAcceptWcPatDate
                                                                    ? new Date(location.flfAcceptWcPatDate).toLocaleDateString('en-US', {
                                                                        year: 'numeric',
                                                                        month: '2-digit',
                                                                        day: '2-digit'
                                                                    })
                                                                    : ''}
                                                            </TableCell>
                                                            {this.state.showServicesTab && (
                                                                <TableCell style={{ wordBreak: 'break-word' }}>
                                                                    {formatItems(location.services)}
                                                                </TableCell>
                                                            )}
                                                            {this.state.showSpecialtiesTab && (
                                                                <TableCell style={{ wordBreak: 'break-word' }}>
                                                                    {formatItems(location.specialties)}
                                                                </TableCell>
                                                            )}

                                                            {!isHospital && (
                                                                <TableCell style={{ wordBreak: 'break-word' }}>
                                                                    {formatFocusAreasComplete(location.details)}
                                                                </TableCell>
                                                            )}
                                                            <TableCell style={{ wordBreak: 'break-word' }}>
                                                                {formatItems(location.languages)}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseChangesSummary} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>

                <div className={classes.root} style={{ width: '100%', maxWidth: '100%' }}>
                    <Paper className={classes.paper} style={{ width: '100%' }}>
                        {/* Combined row for Add Location button and pagination */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '8px 16px',
                            width: '100%'
                        }}>
                            {/* Left side - Add Location button */}
                            <div>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleAddNewLocation}
                                    startIcon={<AddIcon />}
                                    aria-label="Add new location"
                                >
                                    Add Location
                                </Button>
                            </div>

                            {/* Right side - Pagination */}
                            <div>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25, 50, 100, 200]}
                                    component="div"
                                    count={displayLocations.length}
                                    rowsPerPage={this.state.rowsPerPage}
                                    page={this.state.page}
                                    ActionsComponent={TablePaginationActions}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    style={{ marginRight: '-16px' }} // Adjust to align with table edge
                                />
                            </div>
                        </div>

                        <div className={classes.tableWrapper} style={{ width: '100%', maxWidth: '100%' }}>
                            <Table
                                className={classes.table}
                                size='small'
                                aria-label="Physician Location table"
                                style={{ width: '100%' }}
                            >
                                <EnhancedTableHead
                                    classes={classes}
                                    numSelected={0}
                                    order={this.state.order}
                                    orderBy={this.state.orderBy}
                                    onSelectAllClick={() => { }}
                                    onRequestSort={this.handleRequestSort}
                                    onRequestFilter={this.handleRequestFilter}
                                    rowCount={displayLocations.length}
                                />
                                <TableBody className="Demographic">
                                    {stableSort(displayLocations, getSorting(this.state.order, this.state.orderBy))
                                        .filter(row => {
                                            // Filter out locations that were added and then deleted
                                            const addChange = this.state.changeTracking.find(
                                                change => change.id === row.flfFaclocId && change.action === 'add'
                                            );

                                            const deleteChange = this.state.changeTracking.find(
                                                change => change.id === row.flfFaclocId && change.action === 'delete'
                                            );

                                            // If it was both added and deleted, filter it out completely
                                            return !(addChange && deleteChange);
                                        })
                                        .slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                                        .map((row, index) => {
                                            const labelId = `enhanced-table-Select-${index}`;
                                            const isDeleted = this.isLocationDeleted(row.flfFaclocId);
                                            return (
                                                <TableRow
                                                    tabIndex={-1}
                                                    key={row.flfFaclocId}
                                                    style={{
                                                        padding: '5px 20px',
                                                        height: 25,
                                                        backgroundColor: index % 2 ? '#fafafa' : 'white',
                                                        opacity: isDeleted ? 0.7 : 1
                                                    }}
                                                >
                                                    <TableCell component="th" id={labelId} scope="row" size='small'
                                                        className={isDeleted ? classes.deleted : ''}
                                                        style={{ width: '15%' }}
                                                    >

                                                        {row.faclocDirectoryLocName}
                                                    </TableCell>
                                                    <TableCell component="th" id={labelId} scope="row" size='small'
                                                        className={isDeleted ? classes.deleted : ''}
                                                        style={{ width: '20%' }}
                                                    >
                                                        <Tooltip title={row.address} placement="top">
                                                            <div>{row.addressString}</div>
                                                        </Tooltip>
                                                    </TableCell>
                                                    <TableCell component="th" id={labelId} scope="row" size='small'
                                                        className={isDeleted ? classes.deleted : ''}
                                                        style={{ width: '10%' }}
                                                    >
                                                        {row.faclocDirectoryPhoneNbr}
                                                    </TableCell>

                                                    <TableCell component="th" id={labelId} scope="row" size='small'
                                                        className={isDeleted ? classes.deleted : ''}
                                                        style={{ width: '10%' }}
                                                    >
                                                        {row.faclocFaxNbr}
                                                    </TableCell>

                                                    <TableCell component="th" id={labelId} scope="row" size='small'
                                                        className={isDeleted ? classes.deleted : ''}
                                                        style={{ width: '15%' }}
                                                    >
                                                        {row.faclocEmailAddress}
                                                    </TableCell>


                                                    <TableCell component="th" id={labelId} scope="row" size='small'
                                                        className={isDeleted ? classes.deleted : ''}
                                                        style={{ width: '10%' }}
                                                    >
                                                        {formatYesNo(row.flfAcceptWcPatients)}
                                                    </TableCell>
                                                    <TableCell
                                                        component="th"
                                                        id={labelId}
                                                        scope="row"
                                                        size='small'
                                                        className={isDeleted ? classes.deleted : ''}
                                                        style={{ width: '10%' }}
                                                    >
                                                        {((row.services && row.services.length > 0) ||
                                                            (!this.props.type || this.props.type !== "H") &&
                                                            ((row.specialties && row.specialties.length > 0) ||
                                                                (row.focuses && row.focuses.length > 0)) ||
                                                            (row.languages && row.languages.length > 0)) ? // Corrected spelling
                                                            <Link
                                                                onClick={() => this.handleViewDetails(
                                                                    row.services || [],
                                                                    row.specialties || [],
                                                                    row.focuses || [],
                                                                    row.languages || [], // Corrected spelling
                                                                    row.faclocDirectoryLocName
                                                                )}
                                                                aria-label='PROVIDER DEMOGRAPHICS: Facility Locations: Additional Information VIEW DETAILS Hyperlink'
                                                            >
                                                                View Details
                                                            </Link>
                                                            : <span />
                                                        }
                                                    </TableCell>
                                                    <TableCell component="th" id={labelId} scope="row" size='small' style={{ width: '10%' }}>
                                                        {isDeleted ? (
                                                            <Tooltip title="Restore">
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => this.handleUndoDelete(row.flfFaclocId)}
                                                                    aria-label="restore location"
                                                                    color="primary"
                                                                >
                                                                    <RestoreIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        ) : (
                                                            <>
                                                                <Tooltip title="Edit Location">
                                                                    <IconButton
                                                                        aria-label="edit location"
                                                                        onClick={() => this.handleEditLocation(row)}
                                                                        size="small"
                                                                    >
                                                                        <EditIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Delete Location">
                                                                    <IconButton
                                                                        aria-label="delete location"
                                                                        onClick={() => this.handleConfirmDeleteLocation(row.flfFaclocId)}
                                                                        size="small"
                                                                    >
                                                                        <DeleteIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </>
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </div>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '8px 16px',
                            width: '100%'
                        }}>
                            {/* Left side - empty to match layout */}
                            <div>
                                {/* This space intentionally left empty to match the layout of the top bar */}
                            </div>

                            {/* Right side - Pagination */}
                            <div>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25, 50, 100, 200]}
                                    component="div"
                                    count={displayLocations.length}
                                    rowsPerPage={this.state.rowsPerPage}
                                    page={this.state.page}
                                    ActionsComponent={TablePaginationActions}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    style={{ marginRight: '-16px' }} // Adjust to align with table edge
                                />
                            </div>
                        </div>

                        <div className={classes.buttonContainer}>
                            <Button
                                variant="outlined"
                                onClick={this.handleDiscardChanges}
                                startIcon={<UndoIcon />}
                                aria-label="Discard all changes"
                                className={classes.actionButton}
                                disabled={!this.state.hasLocalChanges}
                            >
                                Discard Changes
                            </Button>

                            <Button
                                variant="contained"
                                color="primary"
                                onClick={this.handleShowChanges}
                                startIcon={<VisibilityIcon />}
                                aria-label="Review changes"
                                className={classes.actionButton}
                                disabled={!this.state.hasLocalChanges}
                            >
                                Review Changes
                            </Button>
                        </div>
                    </Paper>
                </div>
            </div>
        );
    }
}

FacilityLocationEdit.propTypes = {
    classes: PropTypes.object.isRequired,
    locations: PropTypes.array.isRequired,
    setFilter: PropTypes.func.isRequired,
    filtered: PropTypes.array.isRequired,
    updateLocations: PropTypes.func,
    forwardedRef: PropTypes.object,
    onSectionSaveLocal: PropTypes.func,
    onSectionDiscardChanges: PropTypes.func,
    onSectionHasChanges: PropTypes.func,
    prvId: PropTypes.string.isRequired
};

// Create a wrapper component that uses forwardRef
const ForwardedFacilityLocationEdit = React.forwardRef((props, ref) => {
    return <FacilityLocationEdit {...props} forwardedRef={ref} />;
});

export default withStyles(useStyles)(ForwardedFacilityLocationEdit);